/* ════════════════════════════════════════════════════════════════════
   PATCHBUILT BUILDER STUDIO — Builder_Studio.js  (File 2 of 2)
   All configuration + logic. Pairs with Builder_Studio.html.

   OPERATOR QUICK REFERENCE
   • Add a patch shape/color  → PATCH_SHAPES (image URL = exact texture
     photo of the real patch; it is BOTH the preview and the clip mask).
   • Tumbler variant IDs      → PRODUCT_TUMBLER.variants
   • Keychain colors/variants → KEYCHAIN_COLORS
   • Prices / bulk tiers      → each product's basePrice / tiers
   • Hide anything            → set active: false
   ════════════════════════════════════════════════════════════════════ */
(function () {
'use strict';

/* ══════════════════════════════════════════
   PATCH SHAPES — IMAGE-BASED
   Each entry's `image` is a CDN photo of the actual patch (exact
   texture & color baked in). The image is used as the on-canvas
   product render AND the engrave clip mask (via its alpha channel).

   To add more shapes or color options later:
     1. Upload a PNG of the patch (transparent background) to Shopify
        Files and copy the CDN URL.
     2. Duplicate an entry below — unique key, label, image, variants.

   ⚠ VARIANT IDS: each shape needs its own adhesive/velcro variant IDs.
   They're pre-filled with your existing Rawhide patch variants as a
   starting point — replace per shape before going live.
══════════════════════════════════════════ */
var PATCH_SHAPES = [
  { key: 'rect-3x2', label: '3×2 Rectangle', active: true, sizeIn: 3,
    image: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/3x2_Rectangle.svg?v=1776955273', svg: '' },
  { key: 'arch', label: '3" Arch', active: true, sizeIn: 3,
    image: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/Arch.svg?v=1776955273', svg: '' },
  { key: 'circle-3', label: '3" Circle', active: true, sizeIn: 3,
    image: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/3-Inch-Circle.svg?v=1781416902', svg: '' },
  { key: 'hex-3-5-wide', label: '3.5" Hexagon', active: true, sizeIn: 3.5,
    image: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/Long_Hexagon.svg?v=1776955273', svg: '' },
  { key: 'circle-2', label: '2" Circle', active: true, sizeIn: 2,
    image: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/2-Inch-Circle.svg?v=1781416902', svg: '' },
  { key: 'cowtag', label: '2.5" Cowtag', active: true, sizeIn: 2.5,
    image: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/Cow_Tag.svg?v=1776955273', svg: '' },
  { key: 'square-2', label: '2" Square', active: true, sizeIn: 2,
    image: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/2-Inch-Squre.svg?v=1781416903', svg: '' },
  { key: 'square-3', label: '3" Square', active: true, sizeIn: 3,
    image: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/3-Inch-Square.svg?v=1781416914', svg: '' },
  { key: '3-5x2', label: '3.5×2', active: true, sizeIn: 3.5,
    image: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/3.5x2_Rectangle.svg?v=1776955273', svg: '' }
];

var PATCH_BACKINGS = [
  { key: 'velcro',   label: 'Velcro® Style Hook',      active: true,
    blurb: 'Attaches to any loop-side velcro panel',
    thumb: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/Velcro.png?v=1776907058' },
  { key: 'adhesive', label: 'Heat Activated Adhesive', active: true,
    blurb: 'Sew-on / iron-on backing, permanent attachment',
    thumb: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/Adhesive.png?v=1776907058' }
];

/* ══════════════════════════════════════════
   PATCH COLORS — leatherette color is the variant driver. Each color has
   its own Shopify variant per backing (velcro / adhesive). `thumb` is the
   swatch shown in the color dropdown. Confirmed variant IDs below.

   PER-COLOR SHAPE PHOTOS (optional): to show shapes in each color's real
   texture, add a shapeImages map keyed by PATCH_SHAPES key, e.g.
       shapeImages: { 'rect-3x2': 'https://...Gray_3x2.png', ... }
   Any shape without an entry falls back to its default image in PATCH_SHAPES.
══════════════════════════════════════════ */
var PATCH_COLORS = [
  { key: 'chestnut-saddle', label: 'Chestnut Saddle Brown', active: true,
    thumb: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/Texture_0003_Saddle-Chestnut.png?v=1781416262',
    engrave: { r: 38, g: 20, b: 9 },
    variants: { velcro: '', adhesive: '' }, shapeImages: {} },


  { key: 'chestnut', label: 'Classic Chestnut Brown', active: true,
    thumb: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/Classic_Chestnut_Brown_0e330c3e-a6f9-4b47-a1bc-3a19f8c4ecf6.png?v=1776896530',
    engrave: { r: 32, g: 16, b: 6 },
    variants: { velcro: '47539650625723', adhesive: '47746234777787' }, shapeImages: {} },


  { key: 'saddle', label: 'Dark Saddle Brown', active: true,
    thumb: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/Dark_Saddle_Brown_b84afc32-ccc2-4f22-a2a1-eed7fd1cfa1d.png?v=1776896530',
    engrave: { r: 28, g: 14, b: 6 },
    variants: { velcro: '47539650560187', adhesive: '47746234712251' }, shapeImages: {} },


  { key: 'light', label: 'Classic Light Brown', active: true,
    thumb: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/Classic_Light_Brown_901e9ba6-f4bb-4051-be7f-f0d09d1787c6.png?v=1776896529',
    engrave: { r: 55, g: 30, b: 8 },
    variants: { velcro: '47539650527419', adhesive: '47746234679483' }, shapeImages: {} },


  { key: 'orange', label: 'Classic Orange', active: true,
    thumb: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/Texture_0009_Classic-Orange.png?v=1781416262',
    engrave: { r: 90, g: 40, b: 8 },
    variants: { velcro: '', adhesive: '' }, shapeImages: {} },


  { key: 'gray', label: 'Classic Gray', active: true,
    thumb: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/Classic_Gray_98cb2269-406b-40db-85ac-4ecc1663dad0.png?v=1776896523',
    engrave: { r: 35, g: 35, b: 35 },
    variants: { velcro: '47539650592955', adhesive: '47746234745019' }, shapeImages: {} },


  { key: 'red', label: 'Classic Red', active: true,
    thumb: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/Texture_0008_Classic-Red.png?v=1781416262',
    engrave: { r: 70, g: 18, b: 18 },
    variants: { velcro: '', adhesive: '' }, shapeImages: {} },


  { key: 'saddle-green', label: 'Dark Saddle Green', active: true,
    thumb: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/Texture_0001_Saddle-Green.png?v=1781416262',
    engrave: { r: 20, g: 34, b: 18 },
    variants: { velcro: '', adhesive: '' }, shapeImages: {} },


  { key: 'saddle-blue', label: 'Dark Saddle Blue', active: true,
    thumb: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/Texture_0002_Saddle-Blue.png?v=1781416262',
    engrave: { r: 18, g: 26, b: 46 },
    variants: { velcro: '', adhesive: '' }, shapeImages: {} },


  { key: 'saddle-red', label: 'Dark Saddle Red', active: true,
    thumb: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/Texture_0000_Saddle-Red.png?v=1781416262',
    engrave: { r: 64, g: 16, b: 16 },
    variants: { velcro: '', adhesive: '' }, shapeImages: {} },


  { key: 'rawhide', label: 'Rawhide', active: true,
    thumb: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/Rawhide.png?v=1776896529',
    engrave: { r: 62, g: 36, b: 14 },
    variants: { velcro: '47746232746171', adhesive: '47746234810555' }, shapeImages: {} },


  { key: 'gold-acrylic', label: 'Brushed Gold Acrylic', active: true,
    thumb: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/Texture_0011_Gold-Acrylic.png?v=1781416265',
    engrave: { r: 70, g: 55, b: 15 },
    variants: { velcro: '', adhesive: '' }, shapeImages: {} },


  { key: 'silver-acrylic', label: 'Brushed Silver Acrylic', active: true,
    thumb: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/Texture_0010_Silver-Acrylic.png?v=1781416262',
    engrave: { r: 60, g: 60, b: 60 },
    variants: { velcro: '', adhesive: '' }, shapeImages: {} },


  { key: 'copper-acrylic', label: 'Brushed Copper Acrylic', active: true,
    thumb: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/Texture_0012_Copper-Acrylic.png?v=1781416262',
    engrave: { r: 80, g: 40, b: 20 },
    variants: { velcro: '', adhesive: '' }, shapeImages: {} }

];

/* ══════════════════════════════════════════
   KEYCHAIN COLORS — one variant per color, 1 or 2 sided at no charge.
   `image` is the on-canvas customizer photo (real blank product photo).
══════════════════════════════════════════ */
var KEYCHAIN_COLORS = [
  { key: 'rawhide',   label: 'Rawhide',   active: true, variantId: '47956281163963',
    image: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/Rawhide_Blank_Keychain2.png?v=1781385195',
    engrave: { r: 62, g: 36, b: 14 } },
  { key: 'buckskin',  label: 'Buckskin',  active: true, variantId: '47956295549115',
    image: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/Buckskin_Blank_Keychain2.png?v=1781385191',
    engrave: { r: 70, g: 44, b: 18 } },
  { key: 'baybrown',  label: 'Bay Brown', active: true, variantId: '47956295516347',
    image: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/Bay_Brown_Blank_Keychain2.png?v=1781385191',
    engrave: { r: 26, g: 14, b: 6 } }
];

/* ══════════════════════════════════════════
   TUMBLER MODELS — pulled from the original tumbler builder. Each model
   carries its own mockup/underlay renders, print area, lid, and variant
   IDs. Add more models (e.g. Polar Camel 30oz) by copying an entry.
══════════════════════════════════════════ */
var TUMBLER_MODELS = [
  {
    key: 'premium-20oz',
    label: 'Premium 20oz (Magnetic Lid)',
    active: false,
    printArea: { x: 0.335, y: 0.205, w: 0.33, h: 0.56 },
    engraveWidthInches: 3.5,
    lid: { key: 'black-mag-slide-lid', label: 'Black Mag Slide Lid',
           image: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/Magnetic_Sliding_Lid.png?v=1781130767' },
    /* Each color is its own Shopify variant (per 1-sided / 2-sided). Add a
       color by copying an entry: give it the color's mockup/underlay/thumb
       and its two variant IDs. */
    colors: [
      { key: 'black', label: 'Black', active: true,
        mockup:   'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/Blank_Mockup.png?v=1781124744',
        underlay: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/Stainless_Underlay_transparent.png?v=1781124743',
        thumbnail:'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/Blank_Mockup.png?v=1781124744',
        /* ⚠ PLACEHOLDER — these are the Polar Camel's IDs. Replace with the
           Premium/Magnetic Black 1-sided & 2-sided variant IDs. */
        variants: { oneSided: '47956268351675', twoSided: '46754618638523' } }
    ]
  },
  {
    key: 'polar-camel-20oz',
    label: 'Polar Camel 20oz (Plastic Lid)',
    active: true,
    printArea: { x: 0.335, y: 0.205, w: 0.33, h: 0.45 },
    engraveWidthInches: 3.5,
    lid: { key: 'plastic-slide-lid', label: 'Plastic Slide Lid',
           image: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/Tumbler_Slider_Lid2_5b2bb3b5-a313-407e-98d9-baa5aafb6a8f.png?v=1776114060' },
    colors: [
      { key: 'black', label: 'Black', active: true,
        mockup:   'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/JDSTumblerMockup.png?v=1781137742',
        underlay: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/JDSTumblerStainless_Overlay.png?v=1781137742',
        thumbnail:'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/JDSTumblerMockup.png?v=1781137742',
        variants: { oneSided: '47956268351675',   // Black 1-Sided
                    twoSided: '46754618638523' } } // Black 2-Sided (+$2.00)
    ]
  },
    {
    key: 'rtic-road-trip',
    label: 'Polar Camel 64oz (Plastic Lid)',
    active: false,
    printArea: { x: 0.335, y: 0.2805, w: 0.33, h: 0.65 },
    engraveWidthInches: 3.5,
    lid: { key: 'plastic-slide-lid', label: 'Plastic Slide Lid',
           image: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/Tumbler_Slider_Lid2_5b2bb3b5-a313-407e-98d9-baa5aafb6a8f.png?v=1776114060' },
    colors: [
      { key: 'plum', label: 'Plum', active: true,
        mockup:   'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/RTic_Tumbler.png?v=1784919645',
        underlay: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/RTIC_Underlay_08cd7bb8-5bcf-4532-a3a1-4725e7a738b6.png?v=1784919752',
        thumbnail:'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/RTic_Tumbler.png?v=1784919334',
        variants: { oneSided: '',   // Black 1-Sided
                    twoSided: '' } } // Black 2-Sided (+$2.00)
    ]
  }
];

/* ══════════════════════════════════════════
   PRODUCT LIBRARY
══════════════════════════════════════════ */
var PRODUCTS = [
  {
    key: 'patch',
    label: 'Custom Patches',
    blurb: 'Laser-engraved leatherette patches. Pick a real-texture shape, drop in your design, choose your backing.',
    cardImage: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/Rawhide_Patch.png?v=1781314954',
    fromPrice: 'From $2.40 in bulk',
    sidesAvailable: 1,
    basePrice: 15.00,                       // 1–14 qty unit price (set to your live price)
    engrave: { r: 45, g: 26, b: 10 },      // default burn color on leatherette
    customCut: true,                       // set false to hide the "Custom Cut" shape option
    defaultColor: 'rawhide',               // color selected when the patch builder opens
    tiers: [                                // qty ≥ 15 bulk pricing (same as current patch builder)
      { minQty: 15,    price: 5.00 }, { minQty: 50,   price: 3.98 },
      { minQty: 100,   price: 3.25 }, { minQty: 250,  price: 2.50 },
      { minQty: 500,   price: 2.45 }, { minQty: 1000, price: 2.40 }
    ],
    tierHint: 'Bulk pricing: 15+ $5.00 · 50+ $3.98 · 100+ $3.25 · 250+ $2.50 · 500+ $2.45 · 1000+ $2.40 each.',
    qtyPresets: [15, 25, 50, 100, 250, 500]
  },
  {
    key: 'tumbler',
    label: 'Custom Engraved Tumblers',
    blurb: 'Powder-coated stainless tumblers. Engraving reveals the steel underneath. Pick your style — optional 2-sided engraving.',
    cardImage: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/Black_Tumbler-Transparent_92e32084-b031-4d8e-8ac6-143f540b093b.png?v=1781421996',
    fromPrice: 'From $15.96 in bulk',
    sidesAvailable: 2,
    twoSidedSurcharge: 2.00,
    models: TUMBLER_MODELS,
    defaultModel: 'polar-camel-20oz',
    basePrice: 29.99,
    tiers: [
      { minQty: 5,  price: 26.99 }, { minQty: 10, price: 23.99 },
      { minQty: 15, price: 20.99 }, { minQty: 20, price: 18.49 },
      { minQty: 25, price: 15.96 }
    ],
    tierHint: 'Bulk pricing: 5+ $26.99 · 10+ $23.99 · 15+ $20.99 · 20+ $18.49 · 25+ $15.96 each. 2-sided engraving adds $2.00 per tumbler.',
    qtyPresets: [1, 10, 25, 50, 75, 100]
  },

  /*
  {
    key: 'keychain',
    label: 'Custom Keychains',
    blurb: 'Laser-engraved leatherette keychain in three colors. Engrave one side or both — the back side is free.',
    cardImage: 'https://cdn.shopify.com/s/files/1/0656/8899/3979/files/PATCHBUILT_KEYCHAIN_MOCKUP.png?v=1781314845',
    fromPrice: '2-sided at no extra charge',
    sidesAvailable: 2,
    twoSidedSurcharge: 0,
    printArea: { x: 0.422, y: 0.372, w: 0.475, h: 0.265 },  // adjust to your keychain photo's engraveable zone
    basePrice: 9.99,
    tiers: [
      { minQty: 25,  price: 7.96 }, { minQty: 50, price: 5.98 },
      { minQty: 75, price: 5.72 }, { minQty: 100, price: 5.49 },
      { minQty: 250, price: 5.00 }

    ],
    tierHint: '',
    qtyPresets: [1, 25, 50, 75, 100, 250]
  } */
];

var TEXT_FONTS = [
  { label: 'Bebas Neue (Bold)', value: '"Bebas Neue", Impact, sans-serif' },
  { label: 'Barlow Condensed',  value: '"Barlow Condensed", sans-serif' },
  { label: 'Oswald',            value: '"Oswald", sans-serif' },
  { label: 'DM Sans (Clean)',   value: '"DM Sans", sans-serif' },
  { label: 'Playfair (Serif)',  value: '"Playfair Display", serif' },
  { label: 'Bangers (Comic)',   value: '"Bangers", cursive' }
];

/* ══════════════════════════════════════════
   STATE
══════════════════════════════════════════ */
var CANVAS_W = 600, CANVAS_H = 450;
/* Tumblers render square (matches the original tumbler builder) so the
   portrait mockup isn't squished into a landscape frame. Patches and
   keychains stay 4:3. Set whenever a product's builder opens. */
function canvasDimsFor(p) {
  return (p && p.key === 'tumbler') ? { w: 600, h: 600 } : { w: 600, h: 450 };
}
function applyCanvasDims(p) {
  var d = canvasDimsFor(p);
  CANVAS_W = d.w; CANVAS_H = d.h;
}
var layerIdSeq = 1;

function isActive(e) { return e && e.active !== false; }

function freshDesign(product) {
  return {
    // product-specific options
    shape:   product.key === 'patch'    ? PATCH_SHAPES.filter(isActive)[0].key : null,
    patchColor: product.key === 'patch' ? (product.defaultColor || PATCH_COLORS.filter(isActive)[0].key) : null,
    shapeRotation: 0,                      // 0/90/180/270 — rotate preset patch shapes
    shapeSizeIn: null,                     // preset shape size (longest side, inches); null = shape default
    customPoints: null,                    // custom-cut polygon (design coords), seeded on demand
    customAdjust: false,                   // whether the cut-outline edit handles are shown
    _rawAutoBoundary: null,                // raw traced boundary from Auto-Cut (pre-offset)
    cutOffset: 8,                          // Auto-Cut margin in px
    customHeightIn: 1.75,                  // finished patch height for custom cut (inches)
    backing: product.key === 'patch'    ? PATCH_BACKINGS.filter(isActive)[0].key : null,
    color:   product.key === 'keychain' ? KEYCHAIN_COLORS.filter(isActive)[0].key : null,
    model:   product.key === 'tumbler'  ? (product.defaultModel || TUMBLER_MODELS.filter(isActive)[0].key) : null,
    tumblerColor: product.key === 'tumbler' ? 'black' : null,
    sidesMode: 1,
    activeSide: 1,
    sides: { 1: { layers: [] }, 2: { layers: [] } },
    activeLayerId: null,
    quantity: 1,
    notes: '',
    confirmed: false,
    rightsConfirmed: false
  };
}

var state = {
  screen: 'library',
  productKey: null,
  snapEnabled: true,   // alignment snapping while dragging layers
  designs: {},      // per-product design state, preserved when browsing the library
  assets: {}        // url → { img, status: 'loading'|'ok'|'error' }
};

function product()  { for (var i = 0; i < PRODUCTS.length; i++) if (PRODUCTS[i].key === state.productKey) return PRODUCTS[i]; return null; }
function design()   { return state.designs[state.productKey]; }
function sideLayers(n) { var d = design(); return d.sides[n || d.activeSide].layers; }
function activeLayer() {
  var d = design(); if (!d || !d.activeLayerId) return null;
  var ls = sideLayers();
  for (var i = 0; i < ls.length; i++) if (ls[i].id === d.activeLayerId) return ls[i];
  return null;
}
function patchShape() {
  var d = design(); if (!d) return null;
  for (var i = 0; i < PATCH_SHAPES.length; i++) if (PATCH_SHAPES[i].key === d.shape) return PATCH_SHAPES[i];
  return PATCH_SHAPES.filter(isActive)[0];
}
function patchColor() {
  var d = design(); if (!d) return activePatchColors()[0];
  var list = activePatchColors();
  for (var i = 0; i < list.length; i++) if (list[i].key === d.patchColor) return list[i];
  return list[0];
}
/* Variant availability: a color shows only if it has at least one backing
   variant; a backing shows for a color only if that variant exists. */
function colorVariantFor(color, backingKey) { return (color && color.variants) ? (color.variants[backingKey] || '') : ''; }
function colorHasAnyVariant(color) { return !!(color && color.variants && (color.variants.velcro || color.variants.adhesive)); }
function activePatchColors() { return PATCH_COLORS.filter(function (c) { return c.active !== false && colorHasAnyVariant(c); }); }
function backingAvailable(color, backingKey) { return !!colorVariantFor(color, backingKey); }
function firstAvailableBacking(color) {
  var bs = PATCH_BACKINGS.filter(isActive);
  for (var i = 0; i < bs.length; i++) if (backingAvailable(color, bs[i].key)) return bs[i].key;
  return bs.length ? bs[0].key : null;
}
/* Ensure the selected backing is one the current color actually offers. */
function ensureBackingForColor() {
  var d = design(), c = patchColor();
  if (!c) return;
  if (!backingAvailable(c, d.backing)) {
    var fb = firstAvailableBacking(c);
    if (fb) d.backing = fb;
  }
}
/* Shape photo for the current color — per-color override if provided,
   otherwise the shape's default image. */
function patchShapeImage(shape, color) {
  if (shape && color && color.shapeImages && color.shapeImages[shape.key]) return color.shapeImages[shape.key];
  return shape && shape.image;
}
/* Per-color photo override (explicit shape photo in that color), if any. */
function patchOverridePhoto(shape, color) {
  return (shape && color && color.shapeImages && color.shapeImages[shape.key]) ? color.shapeImages[shape.key] : '';
}
/* The image used to SIZE and MASK the patch: an explicit color photo wins,
   else the shape's SVG silhouette, else the shape's default photo. */
function patchMaskUrl(shape, color) {
  return patchOverridePhoto(shape, color) || (shape && shape.svg) || (shape && shape.image);
}
/* Texture-fill mode: no explicit photo for this color+shape, but the shape
   has an SVG silhouette → fill that silhouette with the color's texture. */
function patchUsesTexture(shape, color) {
  return !patchOverridePhoto(shape, color) && !!(shape && shape.svg);
}
/* Cover-fit a texture image across a rect (design coords, scaled by q). */
function drawTextureCover(c, img, rect, q) {
  q = q || 1;
  var iw = img.naturalWidth || 1, ih = img.naturalHeight || 1;
  var scale = Math.max((rect.w * q) / iw, (rect.h * q) / ih);
  var w = iw * scale, h = ih * scale;
  c.drawImage(img, (rect.x + rect.w / 2) * q - w / 2, (rect.y + rect.h / 2) * q - h / 2, w, h);
}

/* Paint each shape-grid thumbnail = shape silhouette filled with the
   current color's texture (same compositing as the live preview). */
function paintShapeThumbs() {
  if (product().key !== 'patch') return;
  var pc = patchColor();
  var tex = pc && loadAsset(pc.thumb);
  els.optionsPanel.querySelectorAll('[data-shapethumb]').forEach(function (cv) {
    var key = cv.dataset.shapethumb, shape = null;
    for (var i = 0; i < PATCH_SHAPES.length; i++) if (PATCH_SHAPES[i].key === key) shape = PATCH_SHAPES[i];
    if (!shape) return;
    var override = patchOverridePhoto(shape, pc);
    var silUrl = override || shape.svg || shape.image;
    var sil = silUrl && loadAsset(silUrl);
    var ctx2 = cv.getContext('2d');
    ctx2.clearRect(0, 0, cv.width, cv.height);
    if (!sil || sil.status !== 'ok') return;
    var pad = 0.84, iw = sil.img.naturalWidth || 1, ih = sil.img.naturalHeight || 1;
    var scale = Math.min(cv.width * pad / iw, cv.height * pad / ih);
    var w = iw * scale, h = ih * scale, x = (cv.width - w) / 2, y = (cv.height - h) / 2;
    ctx2.drawImage(sil.img, x, y, w, h);
    if (!override && tex && tex.status === 'ok') {
      ctx2.globalCompositeOperation = 'source-in';
      var ts = Math.max(w / (tex.img.naturalWidth || 1), h / (tex.img.naturalHeight || 1));
      var tw = (tex.img.naturalWidth || 1) * ts, th = (tex.img.naturalHeight || 1) * ts;
      ctx2.drawImage(tex.img, x + w / 2 - tw / 2, y + h / 2 - th / 2, tw, th);
      ctx2.globalCompositeOperation = 'source-over';
    }
  });
}

/* ══════════════════════════════════════════
   CUSTOM CUT — draw-your-own patch outline (ported from the original
   patch builder). The polygon is stored in design coords; the patch
   texture and engraving clip to it, and the operator can drag points
   or add new ones via the midpoint handles.
══════════════════════════════════════════ */
function isCustomCut() { var d = design(); return product().key === 'patch' && d && d.shape === 'custom'; }
function patchShapeRot() { var d = design(); return (product().key === 'patch' && d && !isCustomCut()) ? ((d.shapeRotation || 0) % 360) : 0; }

/* Patch shapes are drawn true-to-scale. PATCH_PPI maps real inches to
   on-canvas pixels so a 2" shape renders smaller than a 3" one, and the
   size slider reads exact inches. ~95px/inch keeps a 4" patch inside the frame. */
var PATCH_PPI = 95;
function presetSizeIn() {
  var d = design(), s = patchShape();
  var v = (typeof d.shapeSizeIn === 'number') ? d.shapeSizeIn : ((s && s.sizeIn) || 2);
  return Math.min(v, presetMaxSizeIn());
}
/* Largest finished size: width ≤ 3.5", height ≤ 3". Derived from the
   shape's true aspect (and current rotation). Returns the max LONGEST side. */
var MAX_W_IN = 3.5, MAX_H_IN = 3;
function presetMaxSizeIn() {
  var s = patchShape();
  var a = s && state.assets[patchMaskUrl(s, patchColor())];
  var natW = (a && a.status === 'ok') ? a.img.naturalWidth : 1;
  var natH = (a && a.status === 'ok') ? a.img.naturalHeight : 1;
  var rot = patchShapeRot();
  if (rot === 90 || rot === 270) { var t = natW; natW = natH; natH = t; }
  var longN = Math.max(natW, natH), shortN = Math.min(natW, natH);
  var ratio = longN ? shortN / longN : 1;          // short / long
  var longIsWidth = natW >= natH;
  var maxLong = longIsWidth ? Math.min(MAX_W_IN, MAX_H_IN / ratio)
                            : Math.min(MAX_H_IN, MAX_W_IN / ratio);
  // round down to the 0.25 step
  return Math.max(1, Math.floor(maxLong / 0.25) * 0.25);
}
/* Exact finished dimensions: longest side = size slider, other side from
   the SVG's true aspect ratio. */
function presetDims() {
  var s = patchShape(), size = presetSizeIn();
  var a = s && state.assets[patchMaskUrl(s, patchColor())];
  var natW = (a && a.status === 'ok') ? a.img.naturalWidth : 1;
  var natH = (a && a.status === 'ok') ? a.img.naturalHeight : 1;
  var longN = Math.max(natW, natH), shortN = Math.min(natW, natH);
  var longSide = size, shortSide = longN ? size * (shortN / longN) : size;
  return (natW >= natH) ? { wIn: longSide, hIn: shortSide } : { wIn: shortSide, hIn: longSide };
}

/* Draw a product photo into `rect` (design coords), optionally rotated in
   90° steps about the rect center. q scales to an offscreen buffer. Used
   for both the visible shape and its alpha clip mask so they stay aligned. */
function drawShapeImage(c, img, rect, rotDeg, q) {
  q = q || 1;
  rotDeg = ((rotDeg || 0) % 360 + 360) % 360;
  var cx = (rect.x + rect.w / 2) * q, cy = (rect.y + rect.h / 2) * q;
  var swapped = (rotDeg === 90 || rotDeg === 270);
  var drawW = (swapped ? rect.h : rect.w) * q;
  var drawH = (swapped ? rect.w : rect.h) * q;
  c.save();
  c.translate(cx, cy);
  c.rotate(rotDeg * Math.PI / 180);
  c.drawImage(img, -drawW / 2, -drawH / 2, drawW, drawH);
  c.restore();
}

/* Base rectangle the default outline is seeded into (centered on canvas). */
function customBaseRect() {
  var w = CANVAS_W * 0.62, h = CANVAS_H * 0.60;
  return { x: (CANVAS_W - w) / 2, y: (CANVAS_H - h) / 2, w: w, h: h };
}
/* Seed a rounded-rectangle polygon (corner arcs approximated with points). */
function seedCustomPoints() {
  var r0 = customBaseRect(), rad = Math.min(r0.w, r0.h) * 0.18;
  var x = r0.x, y = r0.y, w = r0.w, h = r0.h;
  var pts = [];
  function arc(cx, cy, a0, a1) {
    var steps = 4;
    for (var i = 0; i <= steps; i++) {
      var a = a0 + (a1 - a0) * (i / steps);
      pts.push({ x: cx + Math.cos(a) * rad, y: cy + Math.sin(a) * rad });
    }
  }
  arc(x + w - rad, y + rad, -Math.PI / 2, 0);
  arc(x + w - rad, y + h - rad, 0, Math.PI / 2);
  arc(x + rad, y + h - rad, Math.PI / 2, Math.PI);
  arc(x + rad, y + rad, Math.PI, Math.PI * 1.5);
  return pts;
}
function customPoints() {
  var d = design();
  if (!d.customPoints || d.customPoints.length < 3) d.customPoints = seedCustomPoints();
  return d.customPoints;
}
function customBBox() {
  var pts = customPoints(), minX = 1e9, minY = 1e9, maxX = -1e9, maxY = -1e9;
  pts.forEach(function (p) { minX = Math.min(minX, p.x); minY = Math.min(minY, p.y); maxX = Math.max(maxX, p.x); maxY = Math.max(maxY, p.y); });
  return { x: minX, y: minY, w: maxX - minX, h: maxY - minY };
}
function customPath(c, q) {
  var pts = customPoints();
  q = q || 1;
  c.beginPath();
  c.moveTo(pts[0].x * q, pts[0].y * q);
  for (var i = 1; i < pts.length; i++) c.lineTo(pts[i].x * q, pts[i].y * q);
  c.closePath();
}
function findCustomPointAt(x, y) {
  var pts = customPoints(), R = 11 / zoomLevel;
  for (var i = 0; i < pts.length; i++) if (Math.hypot(pts[i].x - x, pts[i].y - y) <= R) return i;
  return -1;
}
function findCustomMidAt(x, y) {
  var pts = customPoints(), R = 10 / zoomLevel;
  for (var i = 0; i < pts.length; i++) {
    var a = pts[i], b = pts[(i + 1) % pts.length];
    var mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2;
    if (Math.hypot(mx - x, my - y) <= R) return i;
  }
  return -1;
}

/* ══════════════════════════════════════════
   AUTO-CUT — trace the outermost edge of the design and wrap it as the
   patch outline (ported from the original patch builder). Operates on the
   active side's layers, using each layer's engrave threshold so the cut
   matches what's actually engraved.
══════════════════════════════════════════ */
function autoDetectOuterHull() {
  var W = 600, H = 450;
  var scale = Math.min(W / CANVAS_W, H / CANVAS_H);
  var mask = new Uint8Array(W * H);
  sideLayers().forEach(function (l) {
    var layerCv = document.createElement('canvas');
    layerCv.width = W; layerCv.height = H;
    var lctx = layerCv.getContext('2d');
    lctx.scale(scale, scale);
    lctx.translate(l.cx, l.cy);
    lctx.rotate(l.rotation || 0);
    if (l.type === 'image' && l.img) {
      lctx.drawImage(l.img, -l.w / 2, -l.h / 2, l.w, l.h);
    } else if (l.type === 'text') {
      var fontSize = Math.max(8, l.h);
      lctx.font = (l.weight || 700) + ' ' + fontSize + 'px ' + l.font;
      lctx.textAlign = 'center'; lctx.textBaseline = 'middle';
      lctx.fillStyle = '#000';
      lctx.fillText(l.text, 0, 0);
    } else if (l.type === 'qr' && l.img) {
      lctx.drawImage(l.img, -l.w / 2, -l.h / 2, l.w, l.h);
    }
    var ld;
    try { ld = lctx.getImageData(0, 0, W, H).data; } catch (e) { return; }
    if (l.type === 'image') {
      var meta = computeThresholdMeta(l);
      for (var pi = 0, jj = 0; jj < ld.length; jj += 4, pi++) {
        var a = ld[jj + 3];
        if (a < 30) continue;
        var lum = 0.299 * ld[jj] + 0.587 * ld[jj + 1] + 0.114 * ld[jj + 2];
        var isMark = meta.invert ? (lum >= meta.threshold) : (lum < meta.threshold);
        if (isMark) mask[pi] = 1;
      }
    } else {
      for (var pi2 = 0, jj2 = 0; jj2 < ld.length; jj2 += 4, pi2++) {
        if (ld[jj2 + 3] >= 30 && ld[jj2] < 128) mask[pi2] = 1;
      }
    }
  });

  var MARGIN = 8;
  for (var my = 0; my < H; my++) for (var mx = 0; mx < W; mx++)
    if (mx < MARGIN || mx >= W - MARGIN || my < MARGIN || my >= H - MARGIN) mask[my * W + mx] = 0;

  var sealed = dilate(dilate(mask, W, H), W, H);
  var outside = new Uint8Array(W * H);
  var stack = [];
  function seedOutside(idx) { if (idx < 0 || idx >= W * H) return; if (sealed[idx] || outside[idx]) return; outside[idx] = 1; stack.push(idx); }
  for (var bx = 0; bx < W; bx++) { seedOutside(bx); seedOutside((H - 1) * W + bx); }
  for (var by = 0; by < H; by++) { seedOutside(by * W); seedOutside(by * W + W - 1); }
  while (stack.length) {
    var cur = stack.pop(), cx = cur % W, cy = (cur - cx) / W;
    if (cx > 0)     { var n1 = cur - 1; if (!sealed[n1] && !outside[n1]) { outside[n1] = 1; stack.push(n1); } }
    if (cx < W - 1) { var n2 = cur + 1; if (!sealed[n2] && !outside[n2]) { outside[n2] = 1; stack.push(n2); } }
    if (cy > 0)     { var n3 = cur - W; if (!sealed[n3] && !outside[n3]) { outside[n3] = 1; stack.push(n3); } }
    if (cy < H - 1) { var n4 = cur + W; if (!sealed[n4] && !outside[n4]) { outside[n4] = 1; stack.push(n4); } }
  }
  var envelope = new Uint8Array(W * H);
  for (var ei = 0; ei < W * H; ei++) envelope[ei] = outside[ei] ? 0 : 1;

  var pts;
  var envCount = countComponents(envelope, W, H);
  if (envCount === 1) {
    var startIdx = -1;
    for (var fi = 0; fi < envelope.length; fi++) if (envelope[fi]) { startIdx = fi; break; }
    if (startIdx >= 0) {
      var traced = mooreTrace(envelope, W, H, startIdx);
      if (traced && traced.length >= 4) {
        pts = douglasPeucker(traced, Math.max(W, H) * 0.0022);
        pts = chaikinSmooth(pts, 4);
        if (pts.length > 240) pts = resamplePolygon(pts, 180);
      }
    }
  } else {
    var passes = 0, merged = false, workMask = sealed;
    for (var dp = 0; dp < 24; dp++) { if (countComponents(workMask, W, H) <= 1) { merged = true; break; } workMask = dilate(workMask, W, H); passes++; }
    if (!merged && countComponents(workMask, W, H) <= 1) merged = true;
    if (merged) {
      var erodeBack = Math.max(0, passes - 2);
      for (var ep = 0; ep < erodeBack; ep++) workMask = erode(workMask, W, H);
      var reHeal = 0;
      while (countComponents(workMask, W, H) > 1 && reHeal < 6) { workMask = dilate(workMask, W, H); reHeal++; }
      var startIdx2 = -1;
      for (var fi2 = 0; fi2 < workMask.length; fi2++) if (workMask[fi2]) { startIdx2 = fi2; break; }
      if (startIdx2 >= 0) {
        var traced2 = mooreTrace(workMask, W, H, startIdx2);
        if (traced2 && traced2.length >= 4) {
          pts = douglasPeucker(traced2, Math.max(W, H) * 0.0022);
          pts = chaikinSmooth(pts, 4);
          if (pts.length > 240) pts = resamplePolygon(pts, 180);
        }
      }
    }
  }

  if (!pts || pts.length < 4) {
    var edgePoints = [];
    for (var y = 0; y < H; y++) for (var x = 0; x < W; x++) {
      var idx = y * W + x;
      if (!mask[idx]) continue;
      var isEdge = (x === 0 || x === W - 1 || y === 0 || y === H - 1) || !mask[idx - 1] || !mask[idx + 1] || !mask[idx - W] || !mask[idx + W];
      if (isEdge) edgePoints.push({ x: x, y: y });
    }
    if (edgePoints.length < 10) return null;
    if (edgePoints.length > 500) { var stride = edgePoints.length / 500, sampled = []; for (var s = 0; s < edgePoints.length; s += stride) sampled.push(edgePoints[Math.floor(s)]); edgePoints = sampled; }
    var hull = concaveHull(edgePoints, 12);
    if (!hull || hull.length < 3) return null;
    pts = douglasPeucker(hull, Math.max(W, H) * 0.0015);
    if (pts.length > 80) pts = resamplePolygon(pts, 70);
  }
  if (!pts || pts.length < 4) return null;
  return pts.map(function (pt) { return { x: pt.x / scale, y: pt.y / scale }; });
}

function countComponents(mask, W, H) {
  var visited = new Uint8Array(W * H), count = 0, stack = [];
  for (var i = 0; i < W * H; i++) {
    if (!mask[i] || visited[i]) continue;
    count++; if (count > 20) return count;
    stack.push(i);
    while (stack.length) {
      var idx = stack.pop();
      if (visited[idx] || !mask[idx]) continue;
      visited[idx] = 1;
      var x = idx % W, y = (idx - x) / W;
      if (x > 0) stack.push(idx - 1); if (x < W - 1) stack.push(idx + 1);
      if (y > 0) stack.push(idx - W); if (y < H - 1) stack.push(idx + W);
    }
  }
  return count;
}
function dilate(src, w, h) {
  var out = new Uint8Array(src.length);
  for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
    var idx = y * w + x;
    if (src[idx]) { out[idx] = 1; continue; }
    if ((x > 0 && src[idx - 1]) || (x < w - 1 && src[idx + 1]) || (y > 0 && src[idx - w]) || (y < h - 1 && src[idx + w])) out[idx] = 1;
  }
  return out;
}
function erode(src, w, h) {
  var out = new Uint8Array(src.length);
  for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
    var idx = y * w + x;
    if (!src[idx]) continue;
    if (x === 0 || x === w - 1 || y === 0 || y === h - 1) { out[idx] = 0; continue; }
    out[idx] = (src[idx - 1] && src[idx + 1] && src[idx - w] && src[idx + w]) ? 1 : 0;
  }
  return out;
}
function mooreTrace(mask, w, h, startIdx) {
  var sx = startIdx % w, sy = (startIdx - sx) / w;
  var dx = [-1, -1, 0, 1, 1, 1, 0, -1], dy = [0, -1, -1, -1, 0, 1, 1, 1];
  var boundary = [{ x: sx, y: sy }], cx = sx, cy = sy, prevDir = 6, steps = 0, MAX = w * h * 4;
  while (steps++ < MAX) {
    var startDir = (prevDir + 6) % 8, found = false;
    for (var k = 0; k < 8; k++) {
      var d = (startDir + k) % 8, nx = cx + dx[d], ny = cy + dy[d];
      if (nx < 0 || nx >= w || ny < 0 || ny >= h) continue;
      if (mask[ny * w + nx]) { cx = nx; cy = ny; prevDir = d; boundary.push({ x: cx, y: cy }); found = true; break; }
    }
    if (!found) break;
    if (cx === sx && cy === sy && boundary.length > 2) break;
    if (boundary.length > w * h) break;
  }
  return boundary;
}
function chaikinSmooth(pts, iters) {
  if (!pts || pts.length < 3) return pts;
  iters = iters || 3;
  var cur = pts.slice();
  for (var it = 0; it < iters; it++) {
    var next = [], n = cur.length;
    for (var i = 0; i < n; i++) {
      var p = cur[i], q = cur[(i + 1) % n];
      next.push({ x: 0.75 * p.x + 0.25 * q.x, y: 0.75 * p.y + 0.25 * q.y });
      next.push({ x: 0.25 * p.x + 0.75 * q.x, y: 0.25 * p.y + 0.75 * q.y });
    }
    cur = next;
  }
  return cur;
}
function douglasPeucker(pts, tol) {
  if (pts.length < 3) return pts.slice();
  function perp(p, a, b) {
    var dx = b.x - a.x, dy = b.y - a.y, l2 = dx * dx + dy * dy;
    if (l2 === 0) return Math.hypot(p.x - a.x, p.y - a.y);
    var t = ((p.x - a.x) * dx + (p.y - a.y) * dy) / l2;
    return Math.hypot(p.x - (a.x + t * dx), p.y - (a.y + t * dy));
  }
  function rec(s_, e, out) {
    var md = 0, mi = -1;
    for (var i = s_ + 1; i < e; i++) { var d = perp(pts[i], pts[s_], pts[e]); if (d > md) { md = d; mi = i; } }
    if (md > tol && mi !== -1) { rec(s_, mi, out); out.push(pts[mi]); rec(mi, e, out); }
  }
  var r = [pts[0]]; rec(0, pts.length - 1, r); r.push(pts[pts.length - 1]);
  var c = [r[0]];
  for (var m = 1; m < r.length; m++) { var prev = c[c.length - 1]; if (r[m].x !== prev.x || r[m].y !== prev.y) c.push(r[m]); }
  if (c.length > 1) { var f = c[0], l = c[c.length - 1]; if (Math.hypot(f.x - l.x, f.y - l.y) < 1.5) c.pop(); }
  return c;
}
function resamplePolygon(pts, n) {
  var perim = 0, seg = [];
  for (var i = 0; i < pts.length; i++) { var a = pts[i], b = pts[(i + 1) % pts.length]; var d = Math.hypot(b.x - a.x, b.y - a.y); seg.push(d); perim += d; }
  var step = perim / n, out = [], covered = 0, target = 0;
  for (var j = 0; j < pts.length; j++) {
    var a2 = pts[j], b2 = pts[(j + 1) % pts.length], L = seg[j];
    while (target <= covered + L && out.length < n) { var t = L === 0 ? 0 : (target - covered) / L; out.push({ x: a2.x + (b2.x - a2.x) * t, y: a2.y + (b2.y - a2.y) * t }); target += step; }
    covered += L;
  }
  return out.length >= 3 ? out : pts;
}
function convexHull(points) {
  var pts = points.slice().sort(function (a, b) { return a.x === b.x ? a.y - b.y : a.x - b.x; });
  function cross(O, A, B) { return (A.x - O.x) * (B.y - O.y) - (A.y - O.y) * (B.x - O.x); }
  var lower = [];
  for (var i = 0; i < pts.length; i++) { while (lower.length >= 2 && cross(lower[lower.length - 2], lower[lower.length - 1], pts[i]) <= 0) lower.pop(); lower.push(pts[i]); }
  var upper = [];
  for (var i2 = pts.length - 1; i2 >= 0; i2--) { while (upper.length >= 2 && cross(upper[upper.length - 2], upper[upper.length - 1], pts[i2]) <= 0) upper.pop(); upper.push(pts[i2]); }
  lower.pop(); upper.pop(); return lower.concat(upper);
}
function concaveHull(points, k) {
  k = Math.max(3, k || 12);
  if (points.length < 3) return points.slice();
  if (points.length < k) return convexHull(points);
  function segInt(p1, p2, p3, p4) { function ccw(A, B, C) { return (C.y - A.y) * (B.x - A.x) > (B.y - A.y) * (C.x - A.x); } return ccw(p1, p3, p4) !== ccw(p2, p3, p4) && ccw(p1, p2, p3) !== ccw(p1, p2, p4); }
  function segIntHull(a, b, hull) { if (hull.length < 3) return false; for (var i = 0; i < hull.length - 2; i++) if (segInt(a, b, hull[i], hull[i + 1])) return true; return false; }
  var seen = {}, pts = [];
  points.forEach(function (p) { var key = p.x + ',' + p.y; if (!seen[key]) { seen[key] = 1; pts.push(p); } });
  if (pts.length < 3) return pts.slice();
  var startIdx = 0;
  for (var i = 1; i < pts.length; i++) if (pts[i].y > pts[startIdx].y || (pts[i].y === pts[startIdx].y && pts[i].x < pts[startIdx].x)) startIdx = i;
  var start = pts[startIdx], hull = [start], current = start, prevAngle = Math.PI;
  var remaining = pts.filter(function (p) { return p.x !== start.x || p.y !== start.y; });
  var step = 0, maxSteps = pts.length * 2;
  while (step++ < maxSteps) {
    var candidates = remaining.slice();
    if (hull.length >= 3) candidates.push(start);
    if (!candidates.length) break;
    candidates.sort(function (a, b) { return ((a.x - current.x) * (a.x - current.x) + (a.y - current.y) * (a.y - current.y)) - ((b.x - current.x) * (b.x - current.x) + (b.y - current.y) * (b.y - current.y)); });
    var nearestK = candidates.slice(0, k);
    nearestK.forEach(function (p) { var ang = Math.atan2(p.y - current.y, p.x - current.x); var turn = prevAngle - ang; while (turn <= 0) turn += Math.PI * 2; while (turn > Math.PI * 2) turn -= Math.PI * 2; p._turn = turn; });
    nearestK.sort(function (a, b) { return b._turn - a._turn; });
    var picked = null;
    for (var c = 0; c < nearestK.length; c++) if (!segIntHull(current, nearestK[c], hull)) { picked = nearestK[c]; break; }
    if (!picked) { if (k < 30) return concaveHull(points, k + 4); return convexHull(points); }
    if (picked.x === start.x && picked.y === start.y) break;
    hull.push(picked);
    prevAngle = Math.atan2(picked.y - current.y, picked.x - current.x) + Math.PI;
    current = picked;
    remaining = remaining.filter(function (p) { return p.x !== picked.x || p.y !== picked.y; });
  }
  return hull;
}
function offsetPolygon(pts, dist) {
  var n = pts.length;
  if (n < 3) return pts.slice();
  var signedArea = 0;
  for (var i = 0; i < n; i++) { var a = pts[i], b = pts[(i + 1) % n]; signedArea += (b.x - a.x) * (b.y + a.y); }
  var normalSign = signedArea <= 0 ? 1 : -1;
  var edgeNormals = [];
  for (var i2 = 0; i2 < n; i2++) { var a2 = pts[i2], b2 = pts[(i2 + 1) % n]; var dx = b2.x - a2.x, dy = b2.y - a2.y; var len = Math.hypot(dx, dy) || 1; edgeNormals.push({ x: (dy / len) * normalSign, y: (-dx / len) * normalSign }); }
  var out = [];
  for (var v = 0; v < n; v++) {
    var prevEdge = edgeNormals[(v + n - 1) % n], nextEdge = edgeNormals[v];
    var nx = prevEdge.x + nextEdge.x, ny = prevEdge.y + nextEdge.y, nlen = Math.hypot(nx, ny);
    if (nlen < 0.0001) { nx = nextEdge.x; ny = nextEdge.y; } else { nx /= nlen; ny /= nlen; }
    var dot = nx * nextEdge.x + ny * nextEdge.y;
    var miter = Math.abs(dot) > 0.2 ? dist / dot : dist;
    out.push({ x: pts[v].x + nx * miter, y: pts[v].y + ny * miter });
  }
  return out;
}
function applyAutoCutOffset() {
  var d = design();
  if (!d._rawAutoBoundary) return;
  var off = (typeof d.cutOffset === 'number') ? d.cutOffset : 8;
  var poly = off > 0 ? offsetPolygon(d._rawAutoBoundary, off) : d._rawAutoBoundary.map(function (p) { return { x: p.x, y: p.y }; });
  // soften any sharp corners the offset introduced
  poly = chaikinSmooth(poly, 2);
  if (poly.length > 220) poly = resamplePolygon(poly, 180);
  d.customPoints = poly;
  render();
}
function runAutoCut() {
  if (!sideLayers().length) { setStatus('Add a layer first, then Auto-Cut.'); return; }
  setStatus('Analyzing design edge…');
  setTimeout(function () {
    var pts = autoDetectOuterHull();
    if (!pts || pts.length < 3) { setStatus('Couldn\u2019t detect an edge — try a transparent PNG.'); return; }
    var d = design();
    d._rawAutoBoundary = pts;
    if (typeof d.cutOffset !== 'number') d.cutOffset = 8;
    applyAutoCutOffset();
    setStatus('Auto-cut complete — drag Cut Margin to adjust the border.');
    refreshOptionsPanel();
  }, 30);
}
function keychainColor() {
  var d = design(); if (!d) return null;
  for (var i = 0; i < KEYCHAIN_COLORS.length; i++) if (KEYCHAIN_COLORS[i].key === d.color) return KEYCHAIN_COLORS[i];
  return KEYCHAIN_COLORS.filter(isActive)[0];
}
function tumblerModel() {
  var d = design(); if (!d) return TUMBLER_MODELS.filter(isActive)[0];
  for (var i = 0; i < TUMBLER_MODELS.length; i++) if (TUMBLER_MODELS[i].key === d.model) return TUMBLER_MODELS[i];
  return TUMBLER_MODELS.filter(isActive)[0];
}
function tumblerColors(m) { m = m || tumblerModel(); return (m.colors || []).filter(isActive); }
function tumblerColor() {
  var d = design(), m = tumblerModel(), cols = tumblerColors(m);
  if (!cols.length) return null;
  for (var i = 0; i < cols.length; i++) if (cols[i].key === (d && d.tumblerColor)) return cols[i];
  return cols[0];
}

/* ══════════════════════════════════════════
   ASSET LOADER (cached by URL)
══════════════════════════════════════════ */
function loadAsset(url) {
  if (!url) return null;
  var a = state.assets[url];
  if (a) return a;
  a = state.assets[url] = { img: new Image(), status: 'loading' };
  a.img.crossOrigin = 'anonymous';
  a.img.onload  = function () { a.status = 'ok';    render(); refreshOptionsPanel(); };
  a.img.onerror = function () { a.status = 'error'; render(); };
  a.img.src = url;
  return a;
}

/* ══════════════════════════════════════════
   DOM
══════════════════════════════════════════ */
function $(id) { return document.getElementById(id); }
var canvas = $('bstCanvas'), ctx = canvas.getContext('2d');
var els = {
  library: $('bstLibrary'), builder: $('bstBuilder'), productGrid: $('bstProductGrid'),
  backBtn: $('bstBackBtn'), builderTitle: $('bstBuilderTitle'),
  status: $('bstStatus'), downloadBtn: $('bstDownloadBtn'), snapToggle: $('bstSnapToggle'),
  optionsTitle: $('bstOptionsTitle'), optionsPanel: $('bstOptionsPanel'), optionsCard: $('bstOptionsCard'),
  sidesCard: $('bstSidesCard'), sidesModeRow: $('bstSidesModeRow'), sidesHint: $('bstSidesHint'),
  side2Note: $('bstSide2Note'), sideTabsWrap: $('bstSideTabsWrap'),
  sideTab1Count: $('bstSideTab1Count'), sideTab2Count: $('bstSideTab2Count'),
  cloneBtn: $('bstCloneBtn'), clearSideBtn: $('bstClearSideBtn'),
  designStepNum: $('bstDesignStepNum'), qtyStepNum: $('bstQtyStepNum'), cartStepNum: $('bstCartStepNum'),
  designSideTag: $('bstDesignSideTag'),
  uploadBtn: $('bstUploadBtn'), fileInput: $('bstFileInput'),
  addTextBtn: $('bstAddTextBtn'), addQrBtn: $('bstAddQrBtn'),
  qrRow: $('bstQrRow'), qrText: $('bstQrText'), qrMakeBtn: $('bstQrMakeBtn'),
  layersList: $('bstLayersList'), layerEmpty: $('bstLayerEmpty'),
  transformPanel: $('bstTransformPanel'),
  textField: $('bstTextField'), textInput: $('bstTextInput'),
  fontField: $('bstFontField'), fontSelect: $('bstFontSelect'),
  scale: $('bstScale'), scaleVal: $('bstScaleVal'),
  rot: $('bstRot'), rotVal: $('bstRotVal'),
  centerBtn: $('bstCenterBtn'), invertBtn: $('bstInvertBtn'),
  dupBtn: $('bstDupBtn'), delBtn: $('bstDelBtn'),
  qtyInput: $('bstQtyInput'), qtyMinus: $('bstQtyMinus'), qtyPlus: $('bstQtyPlus'),
  qtyPresets: $('bstQtyPresets'),
  canvasScroll: $('bstCanvasScroll'),
  zoomSlider: $('bstZoomSlider'), zoomReset: $('bstZoomReset'), zoomVal: $('bstZoomVal'),
  priceTotal: $('bstPriceTotal'), priceUnit: $('bstPriceUnit'), tierHint: $('bstTierHint'),
  notes: $('bstNotes'),
  confirmDesign: $('bstConfirmDesign'), confirmRights: $('bstConfirmRights'),
  addToCartBtn: $('bstAddToCartBtn'), cartMsg: $('bstCartMsg'),
  mobileBar: $('bstMobileBar'), mobileTotal: $('bstMobileTotal'), mobileAddBtn: $('bstMobileAddBtn')
};

/* ══════════════════════════════════════════
   LIBRARY SCREEN
══════════════════════════════════════════ */
(function renderLibrary() {
  els.productGrid.innerHTML = '';
  PRODUCTS.forEach(function (p) {
    var card = document.createElement('button');
    card.type = 'button';
    card.className = 'bst-product-card';
    card.innerHTML =
      '<div class="bst-product-img"><img alt="" loading="lazy"></div>' +
      '<div class="bst-product-body"><h3></h3><p></p>' +
      '<div class="bst-product-meta"><span class="bst-product-price"></span>' +
      '<span class="bst-product-cta">Start Building →</span></div></div>';
    card.querySelector('img').src = p.cardImage;
    card.querySelector('h3').textContent = p.label;
    card.querySelector('p').textContent = p.blurb;
    card.querySelector('.bst-product-price').textContent = p.fromPrice;
    card.addEventListener('click', function () { openBuilder(p.key); });
    els.productGrid.appendChild(card);
  });
})();

function openBuilder(key) {
  state.productKey = key;
  state.screen = 'builder';
  if (!state.designs[key]) state.designs[key] = freshDesign(productByKey(key));
  els.library.hidden = true;
  els.builder.hidden = false;
  els.mobileBar.hidden = false;
  setupBuilderForProduct();
  window.scrollTo({ top: 0 });
}
function productByKey(k) { for (var i = 0; i < PRODUCTS.length; i++) if (PRODUCTS[i].key === k) return PRODUCTS[i]; return null; }

els.backBtn.addEventListener('click', function () {
  state.screen = 'library';
  els.builder.hidden = true;
  els.mobileBar.hidden = true;
  els.library.hidden = false;
  window.scrollTo({ top: 0 });
});

/* ══════════════════════════════════════════
   BUILDER SETUP PER PRODUCT
══════════════════════════════════════════ */
function setupBuilderForProduct() {
  var p = product(), d = design();
  els.builderTitle.innerHTML = 'Building: <span>' + p.label + '</span>';

  // per-product canvas geometry (square for tumblers) + reset zoom
  applyCanvasDims(p);
  zoomLevel = 1; sizeCanvas(); updateZoomUI();

  // preload product imagery
  if (p.key === 'patch') { var pc0 = patchColor(); PATCH_SHAPES.filter(isActive).forEach(function (s) { loadAsset(patchMaskUrl(s, pc0)); }); PATCH_COLORS.filter(isActive).forEach(function (c) { loadAsset(c.thumb); }); }
  if (p.key === 'tumbler') TUMBLER_MODELS.filter(isActive).forEach(function (m) { loadAsset(m.lid.image); (m.colors || []).filter(isActive).forEach(function (c) { loadAsset(c.mockup); loadAsset(c.underlay); }); });
  if (p.key === 'keychain') KEYCHAIN_COLORS.filter(isActive).forEach(function (c) { loadAsset(c.image); });

  // sides card visibility + step numbering
  var multiSide = p.sidesAvailable === 2;
  els.sidesCard.hidden = !multiSide;
  els.designStepNum.textContent = multiSide ? '3' : '2';
  els.qtyStepNum.textContent    = multiSide ? '4' : '3';
  els.cartStepNum.textContent   = multiSide ? '5' : '4';
  if (multiSide) {
    els.side2Note.textContent = p.twoSidedSurcharge > 0
      ? 'Front + back · +$' + p.twoSidedSurcharge.toFixed(2) + ' each'
      : 'Front + back · no extra charge';
    els.sidesHint.textContent = p.twoSidedSurcharge > 0 ? '2-sided uses the 2-sided product variant' : 'Free on this product';
  }

  // restore widget values from this product's saved design
  els.qtyInput.value = d.quantity;
  renderQtyPresets();
  els.notes.value = d.notes;
  els.confirmDesign.checked = d.confirmed;
  els.confirmRights.checked = d.rightsConfirmed;
  els.qrRow.classList.remove('open');

  refreshOptionsPanel();
  refreshSidesUI();
  refreshLayersUI();
  refreshPricing();
  refreshAddToCart();
  showCartMsg(null);
  render();
}

/* options panel (step 1) — rebuilt per product */
function refreshOptionsPanel() {
  if (state.screen !== 'builder') return;
  var p = product(), d = design(), html = '';
  if (p.key === 'patch') {
    els.optionsTitle.textContent = 'Patch Color, Shape & Backing';
    ensureBackingForColor();
    var pc = patchColor();
    var colorOpts = activePatchColors().map(function (c) {
      return '<button type="button" class="bst-thumb-opt' + (pc && pc.key === c.key ? ' active' : '') + '" data-patchcolor="' + c.key + '">' +
        '<span class="bst-ts-thumb cover"><img src="' + c.thumb + '" alt=""></span>' +
        '<span class="bst-ts-label">' + c.label + '</span></button>';
    }).join('');
    var colorDropdown = '<p class="bst-sub">Leatherette color</p>' +
      '<div class="bst-thumb-select" id="bstColorSelect">' +
        '<button type="button" data-ts-toggle>' +
          '<span class="bst-ts-thumb cover"><img src="' + pc.thumb + '" alt=""></span>' +
          '<span class="bst-ts-label">' + pc.label + '</span>' +
          '<span class="bst-ts-caret">▾</span>' +
        '</button>' +
        '<div class="bst-thumb-menu" id="bstColorMenu">' + colorOpts + '</div>' +
      '</div>';
    var shapes = PATCH_SHAPES.filter(isActive).map(function (s) {
      return '<button type="button" class="bst-opt-btn' + (d.shape === s.key ? ' active' : '') + '" data-shape="' + s.key + '">' +
        '<span class="bst-opt-thumb"><canvas class="bst-shape-thumb" data-shapethumb="' + s.key + '" width="120" height="120"></canvas></span>' +
        '<span class="bst-opt-label">' + s.label + '</span></button>';
    }).join('');
    if (p.customCut) {
      shapes += '<button type="button" class="bst-opt-btn' + (d.shape === 'custom' ? ' active' : '') + '" data-shape="custom">' +
        '<span class="bst-opt-thumb" style="background:#1c1c1c;color:var(--gold-lt);font-size:22px;">✂</span>' +
        '<span class="bst-opt-label">Custom Cut</span></button>';
    }
    var customTools = '';
    if (d.shape === 'custom') {
      var hasAuto = !!d._rawAutoBoundary;
      var off = (typeof d.cutOffset === 'number') ? d.cutOffset : 8;
      var hIn = (typeof d.customHeightIn === 'number') ? d.customHeightIn : 1.75;
      var bbc = customBBox();
      var wIn = bbc.h > 0 ? (hIn * (bbc.w / bbc.h)) : hIn;
      customTools = '<div class="bst-side-tools" style="margin-top:10px;">' +
        '<button type="button" class="bst-mini-btn" id="bstAutoCut">\u2728 Auto-Cut From Design</button>' +
        '<button type="button" class="bst-mini-btn' + (d.customAdjust ? ' active-tool' : '') + '" id="bstCustomAdjust">' + (d.customAdjust ? '\u2713 Adjusting Outline' : '\u270e Adjust Cut Outline') + '</button>' +
        '<button type="button" class="bst-mini-btn" id="bstCustomReset">\u27f3 Reset Outline</button>' +
        '</div>' +
        '<div class="bst-field" style="margin-top:12px;"><label>Patch Height <output id="bstCutHeightVal">' + hIn.toFixed(2) + '" &middot; \u2248 ' + wIn.toFixed(2) + '" wide</output></label>' +
          '<input type="range" class="bst-range" id="bstCutHeight" min="1.75" max="3" step="0.25" value="' + hIn + '"></div>' +
        (hasAuto ? ('<div class="bst-field" style="margin-top:10px;"><label>Cut Margin <output id="bstCutMarginVal">' + off + 'px</output></label>' +
          '<input type="range" class="bst-range" id="bstCutMargin" min="0" max="40" value="' + off + '"></div>') : '') +
        '<p class="bst-sub" style="margin-top:8px;margin-bottom:0;">Auto-Cut wraps your artwork. Or drag the points to shape it by hand — tap a midpoint (+) to add a point.</p>';
    }
    var anyBackingUnavailable = false;
    var backs = PATCH_BACKINGS.filter(isActive).map(function (b) {
      var avail = backingAvailable(pc, b.key);
      if (!avail) anyBackingUnavailable = true;
      return '<button type="button" class="bst-opt-btn' + (d.backing === b.key ? ' active' : '') + (avail ? '' : ' disabled') + '"' +
        (avail ? '' : ' disabled aria-disabled="true"') +
        ' data-backing="' + b.key + '" title="' + (avail ? b.blurb : b.label + ' is not available in this color') + '">' +
        '<span class="bst-opt-thumb"><img src="' + b.thumb + '" alt="" loading="lazy"></span>' +
        '<span class="bst-opt-label">' + b.label + (avail ? '' : ' — N/A') + '</span></button>';
    }).join('');
    var backingNote = anyBackingUnavailable
      ? '<p class="bst-sub" style="margin-top:6px;">Greyed-out backings aren\u2019t available in this color.</p>'
      : '';
    var rotTool = '';
    if (d.shape !== 'custom') {
      var ssize = presetSizeIn();
      var pdims = presetDims();
      var maxSize = presetMaxSizeIn();
      // tick marks every 0.25" across the slider range
      var ticks = '', steps = Math.round((maxSize - 1) / 0.25);
      for (var ti = 0; ti <= steps; ti++) {
        var tv = 1 + ti * 0.25, pct = (tv - 1) / (maxSize - 1) * 100;
        var major = (Math.abs(tv - Math.round(tv)) < 0.001);
        ticks += '<span class="bst-tick' + (major ? ' major' : '') + '" style="left:' + pct + '%;"></span>';
      }
      var common = (maxSize >= 3) ? '<span class="bst-tick-marker" style="left:' + ((3 - 1) / (maxSize - 1) * 100) + '%;"><span class="bst-tick-dot"></span><span class="bst-tick-lbl">Most common 3&quot;</span></span>' : '';
      rotTool =
        '<div class="bst-side-tools" style="margin-top:10px;">' +
          '<button type="button" class="bst-mini-btn" id="bstShapeRotate">\u27f3 Rotate 90\u00b0' + ((d.shapeRotation || 0) ? ' (' + (d.shapeRotation || 0) + '\u00b0)' : '') + '</button>' +
        '</div>' +
        '<div class="bst-field" style="margin-top:14px;"><label>Patch Size <output id="bstShapeSizeVal">' + pdims.wIn.toFixed(2) + '" W \u00d7 ' + pdims.hIn.toFixed(2) + '" H</output></label>' +
          '<div class="bst-range-wrap">' +
            '<input type="range" class="bst-range" id="bstShapeSize" min="1" max="' + maxSize + '" step="0.25" value="' + ssize + '">' +
            '<div class="bst-range-ticks">' + ticks + common + '</div>' +
          '</div>' +
          '<p class="bst-sub" style="margin-top:14px;margin-bottom:0;">Max size 3.5" wide / 3" tall. Need larger? <a href="https://patchbuilt.com/pages/contact" target="_blank" rel="noopener" class="bst-link">Contact us for pricing</a>.</p>' +
        '</div>';
    }
    html = colorDropdown +
           '<p class="bst-sub" style="margin-top:14px;">Shape</p>' +
           '<div class="bst-opt-grid">' + shapes + '</div>' + rotTool + customTools +
           '<p class="bst-sub" style="margin-top:16px;">Backing</p>' +
           '<div class="bst-opt-grid" style="grid-template-columns:repeat(2,1fr);">' + backs + '</div>' + backingNote;
  } else if (p.key === 'tumbler') {
    els.optionsTitle.textContent = 'Tumbler Style';
    var m = tumblerModel();
    var opts = TUMBLER_MODELS.filter(isActive).map(function (tm) {
      return '<button type="button" class="bst-thumb-opt' + (m && m.key === tm.key ? ' active' : '') + '" data-model="' + tm.key + '">' +
        '<span class="bst-ts-thumb cover"><img src="' + ((tm.colors && tm.colors[0] && tm.colors[0].thumbnail) || '') + '" alt=""></span>' +
        '<span class="bst-ts-label">' + tm.label + '</span></button>';
    }).join('');
    var tcol = tumblerColor();
    var colOpts = tumblerColors(m).map(function (c) {
      return '<button type="button" class="bst-thumb-opt' + (tcol && tcol.key === c.key ? ' active' : '') + '" data-tcolor="' + c.key + '">' +
        '<span class="bst-ts-thumb cover"><img src="' + c.thumbnail + '" alt=""></span>' +
        '<span class="bst-ts-label">' + c.label + '</span></button>';
    }).join('');
    html = '<p class="bst-sub">Black powder-coated stainless — engraving reveals the steel underneath. Pick a style.</p>' +
           '<div class="bst-thumb-select" id="bstModelSelect">' +
             '<button type="button" data-ts-toggle>' +
               '<span class="bst-ts-thumb cover"><img src="' + (tcol ? tcol.thumbnail : '') + '" alt=""></span>' +
               '<span class="bst-ts-label">' + m.label + '</span>' +
               '<span class="bst-ts-caret">▾</span>' +
             '</button>' +
             '<div class="bst-thumb-menu" id="bstModelMenu">' + opts + '</div>' +
           '</div>' +
           '<div class="bst-split2">' +
             '<div class="bst-split2-col">' +
               '<p class="bst-sub" style="margin:0 0 8px;">Color</p>' +
               '<div class="bst-thumb-select" id="bstTColorSelect">' +
                 '<button type="button" data-ts-toggle>' +
                   '<span class="bst-ts-thumb cover"><img src="' + (tcol ? tcol.thumbnail : '') + '" alt=""></span>' +
                   '<span class="bst-ts-label">' + (tcol ? tcol.label : 'Black') + '</span>' +
                   '<span class="bst-ts-caret">▾</span>' +
                 '</button>' +
                 '<div class="bst-thumb-menu" id="bstTColorMenu">' + colOpts + '</div>' +
               '</div>' +
             '</div>' +
             '<div class="bst-split2-col">' +
               '<p class="bst-sub" style="margin:0 0 8px;">Included Lid</p>' +
               '<div class="bst-opt-btn active" style="cursor:default;justify-content:flex-start;width:100%;"><span class="bst-opt-thumb"><img src="' + m.lid.image + '" alt=""></span><span class="bst-opt-label">' + m.lid.label + '</span></div>' +
             '</div>' +
           '</div>';
  } else if (p.key === 'keychain') {
    els.optionsTitle.textContent = 'Keychain Color';
    var cols = KEYCHAIN_COLORS.filter(isActive).map(function (c) {
      return '<button type="button" class="bst-opt-btn' + (d.color === c.key ? ' active' : '') + '" data-color="' + c.key + '">' +
        '<span class="bst-opt-thumb"><img src="' + c.image + '" alt="" loading="lazy"></span>' +
        '<span class="bst-opt-label">' + c.label + '</span></button>';
    }).join('');
    html = '<div class="bst-opt-grid" style="grid-template-columns:repeat(3,1fr);">' + cols + '</div>';
  }
  els.optionsPanel.innerHTML = html;
  paintShapeThumbs();

  els.optionsPanel.querySelectorAll('[data-shape]').forEach(function (b) {
    b.addEventListener('click', function () {
      var d = design(), was = d.shape;
      d.shape = b.dataset.shape;
      if (d.shape !== 'custom') {
        var ns = patchShape();
        d.shapeSizeIn = (ns && ns.sizeIn) || 2;   // default to the shape's true size
      } else { d.customAdjust = false; }
      refreshAddToCart();
      refreshOptionsPanel();
      if (d.shape === 'custom' && was !== 'custom' && sideLayers().length) { runAutoCut(); }
      else { render(); }
    });
  });
  els.optionsPanel.querySelectorAll('[data-backing]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.disabled || !backingAvailable(patchColor(), b.dataset.backing)) return;
      design().backing = b.dataset.backing; refreshOptionsPanel(); refreshAddToCart();
    });
  });
  els.optionsPanel.querySelectorAll('[data-color]').forEach(function (b) {
    b.addEventListener('click', function () { design().color = b.dataset.color; refreshOptionsPanel(); refreshAddToCart(); render(); });
  });
  els.optionsPanel.querySelectorAll('[data-patchcolor]').forEach(function (b) {
    b.addEventListener('click', function () { design().patchColor = b.dataset.patchcolor; refreshOptionsPanel(); refreshAddToCart(); render(); });
  });
  var rotBtn = els.optionsPanel.querySelector('#bstShapeRotate');
  if (rotBtn) rotBtn.addEventListener('click', function () {
    var d = design(); d.shapeRotation = ((d.shapeRotation || 0) + 90) % 360;
    refreshOptionsPanel(); render();
  });
  var sizeSlider = els.optionsPanel.querySelector('#bstShapeSize');
  if (sizeSlider) sizeSlider.addEventListener('input', function () {
    design().shapeSizeIn = parseFloat(this.value);
    var pd = presetDims();
    var out = els.optionsPanel.querySelector('#bstShapeSizeVal');
    if (out) out.innerHTML = pd.wIn.toFixed(2) + '" W \u00d7 ' + pd.hIn.toFixed(2) + '" H';
    render();
  });
  var adjBtn = els.optionsPanel.querySelector('#bstCustomAdjust');
  if (adjBtn) adjBtn.addEventListener('click', function () { var d = design(); d.customAdjust = !d.customAdjust; refreshOptionsPanel(); render(); });
  var resetBtn = els.optionsPanel.querySelector('#bstCustomReset');
  if (resetBtn) resetBtn.addEventListener('click', function () { var d = design(); d.customPoints = seedCustomPoints(); d._rawAutoBoundary = null; refreshOptionsPanel(); render(); });
  var autoBtn = els.optionsPanel.querySelector('#bstAutoCut');
  if (autoBtn) autoBtn.addEventListener('click', runAutoCut);
  var marginSlider = els.optionsPanel.querySelector('#bstCutMargin');
  if (marginSlider) marginSlider.addEventListener('input', function () {
    var d = design(); d.cutOffset = parseInt(this.value, 10);
    var out = els.optionsPanel.querySelector('#bstCutMarginVal'); if (out) out.textContent = d.cutOffset + 'px';
    applyAutoCutOffset();
    var hv = els.optionsPanel.querySelector('#bstCutHeightVal'); // width readout depends on bbox, refresh it
    if (hv) { var d2 = design(), bb = customBBox(), h2 = d2.customHeightIn || 1.75; hv.innerHTML = h2.toFixed(2) + '" &middot; \u2248 ' + (bb.h > 0 ? (h2 * bb.w / bb.h) : h2).toFixed(2) + '" wide'; }
  });
  var heightSlider = els.optionsPanel.querySelector('#bstCutHeight');
  if (heightSlider) heightSlider.addEventListener('input', function () {
    var d = design(); d.customHeightIn = parseFloat(this.value);
    var bb = customBBox(), w = bb.h > 0 ? (d.customHeightIn * bb.w / bb.h) : d.customHeightIn;
    var out = els.optionsPanel.querySelector('#bstCutHeightVal');
    if (out) out.innerHTML = d.customHeightIn.toFixed(2) + '" &middot; \u2248 ' + w.toFixed(2) + '" wide';
  });
  els.optionsPanel.querySelectorAll('[data-model]').forEach(function (b) {
    b.addEventListener('click', function () {
      var d = design(); d.model = b.dataset.model;
      var cols = tumblerColors(); // colors of the newly selected model
      if (!cols.some(function (c) { return c.key === d.tumblerColor; })) d.tumblerColor = cols.length ? cols[0].key : null;
      refreshOptionsPanel(); refreshAddToCart(); render();
    });
  });
  els.optionsPanel.querySelectorAll('[data-tcolor]').forEach(function (b) {
    b.addEventListener('click', function () { design().tumblerColor = b.dataset.tcolor; refreshOptionsPanel(); refreshAddToCart(); render(); });
  });
  // thumbnail dropdowns (model + color) — independent open/close
  els.optionsPanel.querySelectorAll('.bst-thumb-select').forEach(function (sel) {
    var btn = sel.querySelector('[data-ts-toggle]');
    var menu = sel.querySelector('.bst-thumb-menu');
    if (!btn || !menu) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var wasOpen = menu.classList.contains('open');
      els.optionsPanel.querySelectorAll('.bst-thumb-menu').forEach(function (mm) { mm.classList.remove('open'); });
      if (!wasOpen) menu.classList.add('open');
    });
  });
  document.addEventListener('click', function () {
    els.optionsPanel.querySelectorAll('.bst-thumb-menu').forEach(function (mm) { mm.classList.remove('open'); });
  });
}

/* ══════════════════════════════════════════
   SIDES (1-sided / 2-sided + Side 1 / Side 2 tabs)
══════════════════════════════════════════ */
function refreshSidesUI() {
  var p = product(), d = design();
  if (p.sidesAvailable !== 2) { d.sidesMode = 1; d.activeSide = 1; els.designSideTag.textContent = ''; return; }

  els.sidesModeRow.querySelectorAll('[data-sides]').forEach(function (b) {
    b.classList.toggle('active', Number(b.dataset.sides) === d.sidesMode);
  });
  els.sideTabsWrap.hidden = d.sidesMode !== 2;
  if (d.sidesMode === 1) d.activeSide = 1;

  els.sideTabsWrap.querySelectorAll('[data-sidetab]').forEach(function (b) {
    b.classList.toggle('active', Number(b.dataset.sidetab) === d.activeSide);
  });
  els.sideTab1Count.textContent = d.sides[1].layers.length + ' layer' + (d.sides[1].layers.length === 1 ? '' : 's');
  els.sideTab2Count.textContent = d.sides[2].layers.length + ' layer' + (d.sides[2].layers.length === 1 ? '' : 's');
  els.cloneBtn.disabled = !d.sides[1].layers.length;
  els.designSideTag.textContent = d.sidesMode === 2 ? ('Editing Side ' + d.activeSide) : '';
}

els.sidesModeRow.addEventListener('click', function (e) {
  var b = e.target.closest('[data-sides]'); if (!b) return;
  var d = design(), mode = Number(b.dataset.sides);
  if (mode === d.sidesMode) return;
  if (mode === 1 && d.sides[2].layers.length) {
    if (!window.confirm('Switch to 1-sided? Your Side 2 design will be kept but won\u2019t be engraved or added to the order.')) return;
  }
  d.sidesMode = mode;
  d.activeSide = 1;
  d.activeLayerId = null;
  refreshSidesUI(); refreshLayersUI(); refreshPricing(); refreshAddToCart(); render();
});

els.sideTabsWrap.addEventListener('click', function (e) {
  var b = e.target.closest('[data-sidetab]'); if (!b) return;
  var d = design();
  d.activeSide = Number(b.dataset.sidetab);
  d.activeLayerId = null;
  refreshSidesUI(); refreshLayersUI(); render();
});

els.cloneBtn.addEventListener('click', function () {
  var d = design();
  if (!d.sides[1].layers.length) return;
  if (d.sides[2].layers.length && !window.confirm('Side 2 already has layers. Replace them with a copy of Side 1?')) return;
  d.sides[2].layers = d.sides[1].layers.map(cloneLayer);
  d.activeSide = 2;
  d.activeLayerId = null;
  refreshSidesUI(); refreshLayersUI(); render();
  setStatus('Side 1 copied to Side 2 — tweak it or leave it identical.');
});

els.clearSideBtn.addEventListener('click', function () {
  var d = design();
  if (!sideLayers().length) return;
  if (!window.confirm('Remove all layers from Side ' + d.activeSide + '?')) return;
  d.sides[d.activeSide].layers = [];
  d.activeLayerId = null;
  refreshSidesUI(); refreshLayersUI(); refreshAddToCart(); render();
});

function cloneLayer(l) {
  var c = {};
  for (var k in l) if (Object.prototype.hasOwnProperty.call(l, k)) c[k] = l[k];
  c.id = layerIdSeq++;
  return c; // img / file shared by reference (immutable sources) — safe
}

/* ══════════════════════════════════════════
   LAYERS — add image / text / QR
══════════════════════════════════════════ */
function printRect() {
  var p = product();
  if (p.key === 'tumbler') {
    var tm = tumblerModel();
    return { x: tm.printArea.x * CANVAS_W, y: tm.printArea.y * CANVAS_H,
             w: tm.printArea.w * CANVAS_W, h: tm.printArea.h * CANVAS_H };
  }
  if (p.key === 'keychain') {
    var r = productImageRect();
    return { x: r.x + p.printArea.x * r.w, y: r.y + p.printArea.y * r.h,
             w: p.printArea.w * r.w, h: p.printArea.h * r.h };
  }
  // patch: design area = the shape image footprint (clipped to its alpha when rendering)
  if (isCustomCut()) {
    var bb = customBBox();
    return { x: bb.x + bb.w * 0.06, y: bb.y + bb.h * 0.06, w: bb.w * 0.88, h: bb.h * 0.88 };
  }
  var pr = productImageRect();
  return { x: pr.x + pr.w * 0.06, y: pr.y + pr.h * 0.06, w: pr.w * 0.88, h: pr.h * 0.88 };
}

/* contain-fit rect for patch shape / keychain photo */
function productImageRect() {
  var p = product(), url = null;
  if (p.key === 'patch')    { var s = patchShape();     url = patchMaskUrl(s, patchColor()); }
  if (p.key === 'keychain') { var c = keychainColor();  url = c && c.image; }
  var a = url && state.assets[url];
  var iw = (a && a.status === 'ok') ? a.img.naturalWidth  : 4;
  var ih = (a && a.status === 'ok') ? a.img.naturalHeight : 3;
  var rot = patchShapeRot();
  if (rot === 90 || rot === 270) { var tmp = iw; iw = ih; ih = tmp; }  // rotated bounds

  // Patch presets render true-to-scale: longest side = the chosen size in inches.
  if (p.key === 'patch' && !isCustomCut()) {
    var longPx = presetSizeIn() * PATCH_PPI;            // longest side in canvas px
    var sc = longPx / Math.max(iw, ih);
    var w = iw * sc, h = ih * sc;
    // never overflow the frame
    var fit = Math.min(1, (CANVAS_W * 0.98) / w, (CANVAS_H * 0.98) / h);
    w *= fit; h *= fit;
    return { x: (CANVAS_W - w) / 2, y: (CANVAS_H - h) / 2, w: w, h: h };
  }

  var pad = 0.96;
  var scale = Math.min(CANVAS_W * pad / iw, CANVAS_H * pad / ih);
  var w2 = iw * scale, h2 = ih * scale;
  return { x: (CANVAS_W - w2) / 2, y: (CANVAS_H - h2) / 2, w: w2, h: h2 };
}

function addLayer(layer) {
  var d = design();
  layer.id = layerIdSeq++;
  sideLayers().push(layer);
  d.activeLayerId = layer.id;
  refreshSidesUI(); refreshLayersUI(); refreshAddToCart(); render();
}

els.uploadBtn.addEventListener('click', function () { els.fileInput.click(); });
els.fileInput.addEventListener('change', function () {
  var file = els.fileInput.files && els.fileInput.files[0];
  els.fileInput.value = '';
  if (!file) return;
  var okType = /^image\/(png|jpe?g|webp|gif)$/i.test(file.type);
  var isSvg = /svg/i.test(file.type) || /\.svg$/i.test(file.name || '');
  if (isSvg || !okType) { setStatus('SVG and other non-image files aren\u2019t accepted \u2014 please upload a PNG, JPG, WEBP, or GIF.'); return; }
  var img = new Image();
  var url = URL.createObjectURL(file);
  img.onload = function () {
    var pr = printRect();
    var maxW = pr.w * 0.7, maxH = pr.h * 0.7;
    var sc = Math.min(maxW / img.naturalWidth, maxH / img.naturalHeight, 1.5);
    addLayer({
      type: 'image', name: file.name, file: file, img: img,
      cx: pr.x + pr.w / 2, cy: pr.y + pr.h / 2,
      w: img.naturalWidth * sc, h: img.naturalHeight * sc,
      rotation: 0, invertApplied: false, _thresholdMeta: null
    });
    setStatus('Image added — drag to position. White backgrounds are stripped automatically.');
  };
  img.onerror = function () { setStatus('Couldn\u2019t read that image file.'); };
  img.src = url;
});

els.addTextBtn.addEventListener('click', function () {
  var pr = printRect();
  addLayer({
    type: 'text', text: 'YOUR TEXT', font: TEXT_FONTS[0].value, weight: 700,
    cx: pr.x + pr.w / 2, cy: pr.y + pr.h / 2,
    w: 140, h: Math.min(48, pr.h * 0.3), rotation: 0
  });
  els.textInput.focus();
  els.textInput.select();
});

/* QR code layer */
els.addQrBtn.addEventListener('click', function () {
  els.qrRow.classList.toggle('open');
  if (els.qrRow.classList.contains('open')) els.qrText.focus();
});
els.qrMakeBtn.addEventListener('click', makeQrLayer);
els.qrText.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); makeQrLayer(); } });

function makeQrLayer() {
  var text = els.qrText.value.trim();
  if (!text) { setStatus('Enter a link or text for the QR code first.'); return; }
  if (typeof window.qrcode !== 'function') {
    setStatus('QR generator is still loading (or was blocked) — try again in a second.');
    return;
  }
  try {
    var qr = window.qrcode(0, 'M'); // auto type number, medium error correction
    qr.addData(text);
    qr.make();
    var n = qr.getModuleCount(), quiet = 2, cell = 12;
    var size = (n + quiet * 2) * cell;
    var qc = document.createElement('canvas');
    qc.width = size; qc.height = size;
    var qctx = qc.getContext('2d');
    qctx.fillStyle = '#000';
    for (var r = 0; r < n; r++) for (var c = 0; c < n; c++) {
      if (qr.isDark(r, c)) qctx.fillRect((c + quiet) * cell, (r + quiet) * cell, cell, cell);
    }
    var img = new Image();
    img.onload = function () {
      var pr = printRect();
      var s = Math.min(pr.w, pr.h) * 0.5;
      addLayer({
        type: 'image', subtype: 'qr', qrText: text,
        name: 'QR: ' + (text.length > 26 ? text.slice(0, 26) + '…' : text),
        file: null, img: img,
        cx: pr.x + pr.w / 2, cy: pr.y + pr.h / 2,
        w: s, h: s, rotation: 0, invertApplied: false,
        _thresholdMeta: { threshold: 128, invert: false }
      });
      els.qrText.value = '';
      els.qrRow.classList.remove('open');
      setStatus('QR code added. Keep it at least 0.6" on the finished product so it scans reliably.');
    };
    img.src = qc.toDataURL('image/png');
  } catch (err) {
    setStatus('Couldn\u2019t generate that QR code — try shorter text.');
  }
}

/* ══════════════════════════════════════════
   LAYERS LIST + TRANSFORM CONTROLS
══════════════════════════════════════════ */
(function fillFonts() {
  TEXT_FONTS.forEach(function (f) {
    var o = document.createElement('option');
    o.value = f.value; o.textContent = f.label;
    els.fontSelect.appendChild(o);
  });
})();

function layerIcon(l) {
  if (l.type === 'text') return '🅰';
  if (l.subtype === 'qr') return '▦';
  return '🖼';
}
function layerLabel(l) {
  if (l.type === 'text') return '"' + l.text + '"';
  return l.name || 'Image layer';
}

function refreshLayersUI() {
  var d = design(), ls = sideLayers();
  els.layersList.innerHTML = '';
  els.layerEmpty.style.display = ls.length ? 'none' : 'block';

  ls.slice().reverse().forEach(function (l) {  // top layer first in list
    var row = document.createElement('div');
    row.className = 'bst-layer-row' + (l.id === d.activeLayerId ? ' active' : '');
    row.innerHTML =
      '<span class="bst-layer-ico">' + layerIcon(l) + '</span>' +
      '<span class="bst-layer-name"></span>' +
      '<span class="bst-layer-acts">' +
        '<button type="button" class="bst-icon-btn" data-act="up" title="Bring forward">▲</button>' +
        '<button type="button" class="bst-icon-btn" data-act="down" title="Send back">▼</button>' +
        '<button type="button" class="bst-icon-btn danger" data-act="del" title="Delete">✕</button>' +
      '</span>';
    row.querySelector('.bst-layer-name').textContent = layerLabel(l);
    row.addEventListener('click', function (e) {
      var act = e.target.closest('[data-act]');
      if (act) {
        e.stopPropagation();
        var idx = ls.indexOf(l);
        if (act.dataset.act === 'del') {
          ls.splice(idx, 1);
          if (d.activeLayerId === l.id) d.activeLayerId = null;
        } else if (act.dataset.act === 'up' && idx < ls.length - 1) {
          ls.splice(idx, 1); ls.splice(idx + 1, 0, l);
        } else if (act.dataset.act === 'down' && idx > 0) {
          ls.splice(idx, 1); ls.splice(idx - 1, 0, l);
        }
        refreshSidesUI(); refreshLayersUI(); refreshAddToCart(); render();
        return;
      }
      d.activeLayerId = l.id;
      refreshLayersUI(); render();
    });
    els.layersList.appendChild(row);
  });

  refreshTransformPanel();
}

function refreshTransformPanel() {
  var l = activeLayer();
  els.transformPanel.classList.toggle('open', !!l);
  if (!l) return;
  var isText = l.type === 'text';
  els.textField.hidden = !isText;
  els.fontField.hidden = !isText;
  if (isText) {
    els.textInput.value = l.text;
    els.fontSelect.value = l.font;
  }
  els.invertBtn.style.display = (l.type === 'image') ? '' : 'none';
  els.scale.value = Math.round(Math.max(20, Math.min(420, l.w)));
  els.scaleVal.textContent = Math.round(l.w) + 'px';
  var deg = Math.round(l.rotation * 180 / Math.PI);
  els.rot.value = deg;
  els.rotVal.textContent = deg + '°';
}

els.textInput.addEventListener('input', function () {
  var l = activeLayer(); if (!l || l.type !== 'text') return;
  l.text = els.textInput.value || ' ';
  refreshLayersUI(); render();
});
els.fontSelect.addEventListener('change', function () {
  var l = activeLayer(); if (!l || l.type !== 'text') return;
  l.font = els.fontSelect.value;
  render();
});
els.scale.addEventListener('input', function () {
  var l = activeLayer(); if (!l) return;
  var newW = Number(els.scale.value);
  var ratio = l.h / Math.max(1, l.w);
  l.w = newW; l.h = newW * ratio;
  els.scaleVal.textContent = Math.round(newW) + 'px';
  render();
});
els.rot.addEventListener('input', function () {
  var l = activeLayer(); if (!l) return;
  l.rotation = Number(els.rot.value) * Math.PI / 180;
  els.rotVal.textContent = els.rot.value + '°';
  render();
});
els.centerBtn.addEventListener('click', function () {
  var l = activeLayer(); if (!l) return;
  var pr = printRect();
  l.cx = pr.x + pr.w / 2; l.cy = pr.y + pr.h / 2;
  render();
});
els.invertBtn.addEventListener('click', function () {
  var l = activeLayer(); if (!l || l.type !== 'image') return;
  l.invertApplied = !l.invertApplied;
  render();
});
els.dupBtn.addEventListener('click', function () {
  var l = activeLayer(); if (!l) return;
  var c = cloneLayer(l);
  c.cx += 18; c.cy += 18;
  sideLayers().push(c);
  design().activeLayerId = c.id;
  refreshSidesUI(); refreshLayersUI(); render();
});
els.delBtn.addEventListener('click', function () {
  var d = design(), l = activeLayer(); if (!l) return;
  var ls = sideLayers();
  ls.splice(ls.indexOf(l), 1);
  d.activeLayerId = null;
  refreshSidesUI(); refreshLayersUI(); refreshAddToCart(); render();
});

/* ══════════════════════════════════════════
   SMART THRESHOLD — same engine as the existing builders.
   Decides which pixels of an upload are "marks": dark-on-white,
   light-on-dark, and transparent files all auto-detect; white
   backgrounds strip automatically.
══════════════════════════════════════════ */
function computeThresholdMeta(layer) {
  if (layer._thresholdMeta) return layer._thresholdMeta;
  var img = layer.img, SAMPLE = 64;
  var sc = document.createElement('canvas');
  sc.width = SAMPLE; sc.height = SAMPLE;
  var sctx = sc.getContext('2d');
  sctx.drawImage(img, 0, 0, SAMPLE, SAMPLE);
  var sd;
  try { sd = sctx.getImageData(0, 0, SAMPLE, SAMPLE).data; }
  catch (e) { return { threshold: 128, invert: false }; }

  var hist = new Uint32Array(256), opaque = 0;
  for (var i = 0; i < sd.length; i += 4) {
    if (sd[i + 3] < 30) continue;
    opaque++;
    hist[Math.round(0.299 * sd[i] + 0.587 * sd[i + 1] + 0.114 * sd[i + 2])]++;
  }
  if (!opaque) return (layer._thresholdMeta = { threshold: 128, invert: false });
  var dark = 0, light = 0;
  for (var k = 0; k < 256; k++) (k < 128 ? dark += hist[k] : light += hist[k]);
  var mono = (dark / opaque > 0.95) || (light / opaque > 0.95);
  var invert = mono ? (light > dark) : (light < dark);
  return (layer._thresholdMeta = { threshold: 128, invert: invert });
}

/* thresholded silhouette of an image layer → opaque black marks */
function drawImageMarks(cctx, layer) {
  var natW = layer.img.naturalWidth || layer.img.width || Math.round(layer.w);
  var natH = layer.img.naturalHeight || layer.img.height || Math.round(layer.h);
  var MAX = 1600;
  if (natW > MAX || natH > MAX) {
    var s = Math.min(MAX / natW, MAX / natH);
    natW = Math.max(1, Math.round(natW * s));
    natH = Math.max(1, Math.round(natH * s));
  }
  var off = document.createElement('canvas');
  off.width = natW; off.height = natH;
  var octx = off.getContext('2d');
  octx.drawImage(layer.img, 0, 0, natW, natH);
  var imgData;
  try { imgData = octx.getImageData(0, 0, natW, natH); }
  catch (e) { // CORS-tainted fallback: draw as-is silhouette
    cctx.drawImage(layer.img, -layer.w / 2, -layer.h / 2, layer.w, layer.h);
    return;
  }
  var d = imgData.data, meta = computeThresholdMeta(layer);
  for (var i = 0; i < d.length; i += 4) {
    var a = d[i + 3];
    if (a < 30) { d[i + 3] = 0; continue; }
    var lum = 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2];
    var isMark = meta.invert ? (lum >= meta.threshold) : (lum < meta.threshold);
    if (layer.invertApplied) isMark = !isMark;
    if (isMark) { d[i] = 0; d[i + 1] = 0; d[i + 2] = 0; d[i + 3] = 255; }
    else d[i + 3] = 0;
  }
  octx.putImageData(imgData, 0, 0);
  cctx.imageSmoothingEnabled = true;
  cctx.imageSmoothingQuality = 'high';
  cctx.drawImage(off, -layer.w / 2, -layer.h / 2, layer.w, layer.h);
}

/* Marks mask for a side: opaque black where the design engraves */
function buildMarksCanvas(side, q, clipToPrintRect) {
  var c = document.createElement('canvas');
  c.width = CANVAS_W * q; c.height = CANVAS_H * q;
  var cctx = c.getContext('2d');
  cctx.scale(q, q);
  if (clipToPrintRect) {
    var pr = printRect();
    cctx.beginPath();
    roundRectPath(cctx, pr.x, pr.y, pr.w, pr.h, 6);
    cctx.clip();
  }
  sideLayersOf(side).forEach(function (l) {
    cctx.save();
    cctx.translate(l.cx, l.cy);
    cctx.rotate(l.rotation);
    if (l.type === 'image' && l.img) {
      drawImageMarks(cctx, l);
    } else if (l.type === 'text') {
      var fs = Math.max(8, l.h);
      cctx.font = l.weight + ' ' + fs + 'px ' + l.font;
      cctx.textAlign = 'center';
      cctx.textBaseline = 'middle';
      var m = cctx.measureText(l.text);
      l.w = Math.max(40, m.width);
      cctx.fillStyle = '#000';
      cctx.fillText(l.text, 0, 0);
    }
    cctx.restore();
  });
  return c;
}
function sideLayersOf(n) { return design().sides[n].layers; }

function roundRectPath(c, x, y, w, h, r) {
  c.moveTo(x + r, y); c.lineTo(x + w - r, y); c.quadraticCurveTo(x + w, y, x + w, y + r);
  c.lineTo(x + w, y + h - r); c.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
  c.lineTo(x + r, y + h); c.quadraticCurveTo(x, y + h, x, y + h - r);
  c.lineTo(x, y + r); c.quadraticCurveTo(x, y, x + r, y); c.closePath();
}

/* ══════════════════════════════════════════
   RENDER ENGINE
══════════════════════════════════════════ */
function getDpr() { return Math.min(window.devicePixelRatio || 1, 3); }

/* ── ZOOM ── magnifies content in place about the canvas center. The
   backing store and display size stay fixed, so the frame never grows;
   content beyond the edges is simply clipped. */
var zoomLevel = 1;
function sizeCanvas() {
  var dpr = getDpr();
  canvas.width = Math.round(CANVAS_W * dpr);
  canvas.height = Math.round(CANVAS_H * dpr);
  canvas.style.width = '100%';
  canvas.style.height = 'auto';
}
function applyZoom(z) {
  z = Math.max(1, Math.min(4, z));
  zoomLevel = z; updateZoomUI(); render();
}
function updateZoomUI() {
  if (els.zoomVal) els.zoomVal.textContent = Math.round(zoomLevel * 100) + '%';
  if (els.zoomSlider) els.zoomSlider.value = Math.round(zoomLevel * 100);
}
function resetZoom() { applyZoom(1); }
sizeCanvas();
window.addEventListener('resize', function () { sizeCanvas(); render(); });

function render() {
  if (state.screen !== 'builder') return;
  var dpr = getDpr(), z = zoomLevel, cxp = CANVAS_W / 2, cyp = CANVAS_H / 2;
  ctx.setTransform(1, 0, 0, 1, 0, 0);
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  // zoom magnifies about the design center; edges clip to the canvas
  ctx.setTransform(dpr * z, 0, 0, dpr * z, dpr * cxp * (1 - z), dpr * cyp * (1 - z));

  renderScene(ctx, design().activeSide, 2);

  // guides + selection (preview only)
  drawPrintAreaGuide();
  if (isCustomCut() && design().customAdjust) drawCustomOutline();
  var l = activeLayer();
  if (l) drawSelectionOverlay(l);
}

/* Renders the full product scene for a given side onto targetCtx.
   Shared by the live preview, mockup export, and cart files. */
function renderScene(tctx, side, q) {
  var p = product();
  tctx.fillStyle = '#f5f5f5';
  tctx.fillRect(0, 0, CANVAS_W, CANVAS_H);
  tctx.imageSmoothingEnabled = true;
  tctx.imageSmoothingQuality = 'high';

  if (p.key === 'tumbler') renderTumblerScene(tctx, side, q);
  else renderFlatProductScene(tctx, side, q);

  // side tag for 2-sided products (so order files are unambiguous)
  if (p.sidesAvailable === 2 && design().sidesMode === 2) {
    tctx.save();
    tctx.font = '800 13px "Barlow Condensed", sans-serif';
    tctx.fillStyle = 'rgba(0,0,0,0.45)';
    tctx.textAlign = 'left';
    tctx.fillText('SIDE ' + side, 12, 22);
    tctx.restore();
  }
}

/* Custom-cut patch: leatherette texture filled into the polygon, engraving
   (75% black) clipped to it. No product photo — the cut is operator-drawn. */
function renderCustomPatchScene(tctx, side, q) {
  var pc = patchColor();
  var tex = pc && loadAsset(pc.thumb);
  var bb = customBBox();

  // texture (or fallback color) clipped to the polygon
  tctx.save();
  customPath(tctx, 1);
  tctx.clip();
  if (tex && tex.status === 'ok') {
    var srcH = Math.floor(tex.img.naturalHeight * 0.55) || tex.img.naturalHeight;
    tctx.drawImage(tex.img, 0, 0, tex.img.naturalWidth, srcH, bb.x, bb.y, bb.w, bb.h);
  } else {
    tctx.fillStyle = '#4a2e14';
    tctx.fillRect(bb.x, bb.y, bb.w, bb.h);
  }
  tctx.restore();

  var ls = sideLayersOf(side);
  if (!ls.length) {
    tctx.save();
    tctx.fillStyle = 'rgba(0,0,0,0.3)';
    tctx.font = '700 13px "Barlow Condensed", sans-serif';
    tctx.textAlign = 'center';
    tctx.fillText('ADD A LAYER TO SEE YOUR ENGRAVING', bb.x + bb.w / 2, bb.y + bb.h / 2);
    tctx.restore();
  } else {
    var marks = buildMarksCanvas(side, q, false);
    var eng = document.createElement('canvas');
    eng.width = CANVAS_W * q; eng.height = CANVAS_H * q;
    var ectx = eng.getContext('2d');
    ectx.drawImage(marks, 0, 0);
    ectx.globalCompositeOperation = 'source-in';
    ectx.fillStyle = '#000';
    ectx.fillRect(0, 0, eng.width, eng.height);
    ectx.globalCompositeOperation = 'destination-in';
    customPath(ectx, q); ectx.fill();
    tctx.save();
    tctx.globalAlpha = 0.75;
    tctx.drawImage(eng, 0, 0, CANVAS_W, CANVAS_H);
    tctx.restore();
  }

  // subtle cut border
  tctx.save();
  customPath(tctx, 1);
  tctx.lineWidth = 2;
  tctx.strokeStyle = 'rgba(255,255,255,0.18)';
  tctx.stroke();
  tctx.restore();
}

/* Edit overlay for the custom outline (preview only, never exported). */
function drawCustomOutline() {
  var pts = customPoints();
  ctx.save();
  ctx.strokeStyle = 'rgba(201,146,42,0.9)';
  ctx.lineWidth = 2; ctx.setLineDash([5, 4]);
  customPath(ctx, 1); ctx.stroke();
  ctx.setLineDash([]);
  // midpoint add-handles
  for (var i = 0; i < pts.length; i++) {
    var a = pts[i], b = pts[(i + 1) % pts.length];
    var mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2;
    ctx.beginPath(); ctx.arc(mx, my, 6, 0, Math.PI * 2);
    ctx.fillStyle = 'rgba(17,17,17,0.85)'; ctx.fill();
    ctx.strokeStyle = '#e0a730'; ctx.lineWidth = 1.5;
    ctx.beginPath(); ctx.moveTo(mx - 3, my); ctx.lineTo(mx + 3, my); ctx.moveTo(mx, my - 3); ctx.lineTo(mx, my + 3); ctx.stroke();
  }
  // anchor points
  pts.forEach(function (p) {
    ctx.beginPath(); ctx.arc(p.x, p.y, 7, 0, Math.PI * 2);
    ctx.fillStyle = 'rgba(201,146,42,0.18)'; ctx.fill();
    ctx.beginPath(); ctx.arc(p.x, p.y, 4.5, 0, Math.PI * 2);
    ctx.fillStyle = '#c9922a'; ctx.fill();
    ctx.strokeStyle = '#111'; ctx.lineWidth = 1.5; ctx.stroke();
  });
  ctx.restore();
}

/* Patch + keychain: real product photo + burn-colored marks clipped to its alpha */
function renderFlatProductScene(tctx, side, q) {
  var p = product(), d = design();
  if (p.key === 'patch' && d.shape === 'custom') { renderCustomPatchScene(tctx, side, q); return; }

  var rect = productImageRect(), rot = patchShapeRot();
  var isPatch = (p.key === 'patch');
  var shape = isPatch ? patchShape() : null;
  var color = isPatch ? patchColor() : keychainColor();
  var maskUrl = isPatch ? patchMaskUrl(shape, color) : (color && color.image);
  var useTexture = isPatch && !patchOverridePhoto(shape, color);

  var maskAsset = maskUrl && loadAsset(maskUrl);
  var texAsset  = useTexture ? loadAsset(color.thumb) : null;

  if (!maskAsset || maskAsset.status !== 'ok' || (useTexture && (!texAsset || texAsset.status !== 'ok'))) {
    tctx.fillStyle = 'rgba(0,0,0,0.35)';
    tctx.font = '700 14px "Barlow Condensed", sans-serif';
    tctx.textAlign = 'center';
    var errored = (maskAsset && maskAsset.status === 'error') || (texAsset && texAsset.status === 'error');
    tctx.fillText(errored ? 'COULD NOT LOAD PRODUCT IMAGE' : 'LOADING PRODUCT…', CANVAS_W / 2, CANVAS_H / 2);
    return;
  }

  // ---- blank product (q-res). Its alpha is the shape mask. ----
  var blank = document.createElement('canvas');
  blank.width = CANVAS_W * q; blank.height = CANVAS_H * q;
  var bctx = blank.getContext('2d');
  bctx.imageSmoothingEnabled = true;
  drawShapeImage(bctx, maskAsset.img, rect, rot, q);     // silhouette or photo
  if (useTexture) {                                      // fill silhouette with the color texture
    bctx.globalCompositeOperation = 'source-in';
    drawTextureCover(bctx, texAsset.img, rect, q);
    bctx.globalCompositeOperation = 'source-over';
  }
  tctx.drawImage(blank, 0, 0, CANVAS_W, CANVAS_H);

  var ls = sideLayersOf(side);
  if (!ls.length) {
    tctx.save();
    tctx.fillStyle = 'rgba(0,0,0,0.28)';
    tctx.font = '700 13px "Barlow Condensed", sans-serif';
    tctx.textAlign = 'center';
    tctx.fillText('ADD A LAYER TO SEE YOUR ENGRAVING', CANVAS_W / 2, CANVAS_H / 2);
    tctx.restore();
    return;
  }

  var marks = buildMarksCanvas(side, q, false);

  // colorize marks to solid black, then clip to the product's alpha
  var eng = document.createElement('canvas');
  eng.width = CANVAS_W * q; eng.height = CANVAS_H * q;
  var ectx = eng.getContext('2d');
  ectx.drawImage(marks, 0, 0);
  ectx.globalCompositeOperation = 'source-in';
  ectx.fillStyle = '#000000';
  ectx.fillRect(0, 0, eng.width, eng.height);
  ectx.globalCompositeOperation = 'destination-in';
  ectx.drawImage(blank, 0, 0);                            // clip engraving to the shape alpha

  // keychains: also clip to the defined engrave box (cut off any overflow)
  if (p.key === 'keychain') {
    var kpr = printRect();
    ectx.globalCompositeOperation = 'destination-in';
    ectx.fillStyle = '#000';
    ectx.fillRect(kpr.x * q, kpr.y * q, kpr.w * q, kpr.h * q);
  }

  // engraving overlay: 75% opacity black on the product
  tctx.save();
  tctx.globalCompositeOperation = 'source-over';
  tctx.globalAlpha = 0.75;
  tctx.drawImage(eng, 0, 0, CANVAS_W, CANVAS_H);
  tctx.restore();
}

/* Tumbler: mockup + marks-masked stainless underlay reveal */
function renderTumblerScene(tctx, side, q) {
  var m = tumblerModel(), col = tumblerColor();
  var mock = loadAsset(col ? col.mockup : m.mockup), under = loadAsset(col ? col.underlay : m.underlay);
  if (!mock || mock.status !== 'ok') {
    tctx.fillStyle = '#1a1a1a';
    tctx.fillRect(0, 0, CANVAS_W, CANVAS_H);
    tctx.fillStyle = 'rgba(201,146,42,0.4)';
    tctx.font = '700 14px "Barlow Condensed", sans-serif';
    tctx.textAlign = 'center';
    tctx.fillText(mock && mock.status === 'error' ? 'COULD NOT LOAD TUMBLER IMAGE' : 'LOADING TUMBLER…', CANVAS_W / 2, CANVAS_H / 2);
    return;
  }
  tctx.drawImage(mock.img, 0, 0, CANVAS_W, CANVAS_H);

  var ls = sideLayersOf(side);
  if (!ls.length) {
    var pr0 = printRect();
    tctx.save();
    tctx.fillStyle = 'rgba(255,255,255,0.28)';
    tctx.font = '700 13px "Barlow Condensed", sans-serif';
    tctx.textAlign = 'center';
    tctx.fillText('ADD A LAYER TO SEE YOUR ENGRAVING', pr0.x + pr0.w / 2, pr0.y + pr0.h / 2);
    tctx.restore();
    return;
  }

  var marks = buildMarksCanvas(side, q, true);
  var eng = document.createElement('canvas');
  eng.width = CANVAS_W * q; eng.height = CANVAS_H * q;
  var ectx = eng.getContext('2d');
  ectx.imageSmoothingEnabled = true;
  ectx.imageSmoothingQuality = 'high';
  if (under && under.status === 'ok') {
    ectx.drawImage(under.img, 0, 0, eng.width, eng.height); // pixel-aligned with mockup
  } else {
    var g = ectx.createLinearGradient(0, 0, eng.width, 0);
    g.addColorStop(0, '#9a9a9a'); g.addColorStop(0.35, '#dcdcdc');
    g.addColorStop(0.55, '#c4c4c4'); g.addColorStop(1, '#8e8e8e');
    ectx.fillStyle = g;
    ectx.fillRect(0, 0, eng.width, eng.height);
  }
  ectx.globalCompositeOperation = 'destination-in';
  ectx.drawImage(marks, 0, 0);

  tctx.save();
  tctx.drawImage(eng, 0, 0, CANVAS_W, CANVAS_H);
  tctx.restore();
}

function buildEdgeShade(marks, q) {
  var c = document.createElement('canvas');
  c.width = marks.width; c.height = marks.height;
  var cctx = c.getContext('2d');
  cctx.fillStyle = '#fff';
  cctx.fillRect(0, 0, c.width, c.height);
  cctx.save();
  cctx.filter = 'blur(' + (1.2 * q) + 'px)';
  cctx.drawImage(marks, 0, 0);
  cctx.restore();
  cctx.globalCompositeOperation = 'source-atop';
  cctx.fillStyle = 'rgba(60,60,60,1)';
  cctx.fillRect(0, 0, c.width, c.height);
  cctx.globalCompositeOperation = 'destination-out';
  cctx.drawImage(marks, 0, 0);
  cctx.globalCompositeOperation = 'destination-over';
  cctx.fillStyle = '#fff';
  cctx.fillRect(0, 0, c.width, c.height);
  return c;
}

function drawPrintAreaGuide() {
  var p = product();
  if (p.key === 'patch') return; // the shape itself is the boundary
  var pr = printRect();
  ctx.save();
  ctx.strokeStyle = 'rgba(224,167,48,0.5)';
  ctx.lineWidth = 1;
  ctx.setLineDash([5, 4]);
  ctx.beginPath();
  roundRectPath(ctx, pr.x, pr.y, pr.w, pr.h, 6);
  ctx.stroke();
  ctx.setLineDash([]);
  ctx.font = '700 9px "Barlow Condensed", sans-serif';
  ctx.fillStyle = 'rgba(224,167,48,0.7)';
  ctx.textAlign = 'left';
  ctx.fillText('ENGRAVE AREA', pr.x + 4, pr.y - 5);
  ctx.restore();
}

/* ══════════════════════════════════════════
   SELECTION OVERLAY + POINTER INTERACTION
══════════════════════════════════════════ */
var HANDLE = 10;
var interaction = { mode: null, startX: 0, startY: 0, orig: null };

function getCanvasCoords(clientX, clientY) {
  var r = canvas.getBoundingClientRect();
  var rawX = (clientX - r.left) * (CANVAS_W / r.width);
  var rawY = (clientY - r.top)  * (CANVAS_H / r.height);
  var z = zoomLevel, cxp = CANVAS_W / 2, cyp = CANVAS_H / 2;
  return { x: cxp + (rawX - cxp) / z, y: cyp + (rawY - cyp) / z };
}
function layerCorners(l) {
  var hw = l.w / 2, hh = l.h / 2, cos = Math.cos(l.rotation), sin = Math.sin(l.rotation);
  return [{ x: -hw, y: -hh }, { x: hw, y: -hh }, { x: hw, y: hh }, { x: -hw, y: hh }]
    .map(function (p) { return { x: l.cx + p.x * cos - p.y * sin, y: l.cy + p.x * sin + p.y * cos }; });
}
function rotationHandle(l) {
  var cos = Math.cos(l.rotation), sin = Math.sin(l.rotation), off = -l.h / 2 - 24;
  return { x: l.cx - off * sin, y: l.cy + off * cos };
}
function hitHandle(l, x, y) {
  var cs = layerCorners(l);
  for (var i = 0; i < 4; i++) if (Math.hypot(cs[i].x - x, cs[i].y - y) <= HANDLE + 4) return { type: 'scale' };
  var rh = rotationHandle(l);
  if (Math.hypot(rh.x - x, rh.y - y) <= HANDLE + 4) return { type: 'rotate' };
  return null;
}
function pointInLayer(l, x, y) {
  var cos = Math.cos(-l.rotation), sin = Math.sin(-l.rotation);
  var dx = x - l.cx, dy = y - l.cy;
  return Math.abs(dx * cos - dy * sin) <= l.w / 2 && Math.abs(dx * sin + dy * cos) <= l.h / 2;
}
function findLayerAt(x, y) {
  var ls = sideLayers();
  for (var i = ls.length - 1; i >= 0; i--) if (pointInLayer(ls[i], x, y)) return ls[i];
  return null;
}

function drawSelectionOverlay(l) {
  var cs = layerCorners(l);
  ctx.save();
  ctx.strokeStyle = 'rgba(224,167,48,0.9)';
  ctx.lineWidth = 1.5;
  ctx.setLineDash([4, 3]);
  ctx.beginPath();
  ctx.moveTo(cs[0].x, cs[0].y);
  for (var i = 1; i < 4; i++) ctx.lineTo(cs[i].x, cs[i].y);
  ctx.closePath();
  ctx.stroke();
  ctx.setLineDash([]);
  cs.forEach(function (c) {
    ctx.fillStyle = '#0d0d0d';
    ctx.strokeStyle = '#e0a730';
    ctx.beginPath();
    ctx.arc(c.x, c.y, HANDLE / 2 + 1, 0, Math.PI * 2);
    ctx.fill(); ctx.stroke();
  });
  var rh = rotationHandle(l);
  ctx.beginPath();
  ctx.moveTo((cs[0].x + cs[1].x) / 2, (cs[0].y + cs[1].y) / 2);
  ctx.lineTo(rh.x, rh.y);
  ctx.strokeStyle = 'rgba(224,167,48,0.6)';
  ctx.stroke();
  ctx.fillStyle = '#e0a730';
  ctx.beginPath();
  ctx.arc(rh.x, rh.y, HANDLE / 2 + 1, 0, Math.PI * 2);
  ctx.fill();
  ctx.restore();
}

function onPointerDown(e) {
  if (state.screen !== 'builder') return;
  var c = getCanvasCoords(e.clientX, e.clientY);
  var d = design(), act = activeLayer();

  // custom-cut outline editing takes priority while adjusting
  if (isCustomCut() && d.customAdjust) {
    var pi = findCustomPointAt(c.x, c.y);
    if (pi >= 0) {
      interaction.mode = 'cpoint'; interaction.cpIdx = pi; e.preventDefault(); return;
    }
    var mi = findCustomMidAt(c.x, c.y);
    if (mi >= 0) {
      var a = d.customPoints[mi], b = d.customPoints[(mi + 1) % d.customPoints.length];
      d.customPoints.splice(mi + 1, 0, { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 });
      interaction.mode = 'cpoint'; interaction.cpIdx = mi + 1; render(); e.preventDefault(); return;
    }
    // tapping empty space while adjusting: ignore (don't grab layers)
    return;
  }

  if (act) {
    var h = hitHandle(act, c.x, c.y);
    if (h) {
      interaction.mode = h.type;
      interaction.startX = c.x; interaction.startY = c.y;
      interaction.orig = cloneShallow(act);
      e.preventDefault();
      return;
    }
  }
  var hit = findLayerAt(c.x, c.y);
  if (hit) {
    if (hit.id !== d.activeLayerId) { d.activeLayerId = hit.id; refreshLayersUI(); }
    interaction.mode = 'move';
    interaction.startX = c.x; interaction.startY = c.y;
    interaction.orig = cloneShallow(hit);
    canvas.style.cursor = 'move';
    render();            // show the selection box on click, before any drag
    e.preventDefault();
  } else if (d.activeLayerId) {
    d.activeLayerId = null;
    refreshLayersUI(); render();
  }
}
function cloneShallow(o) { var c = {}; for (var k in o) c[k] = o[k]; return c; }

function onPointerMove(e) {
  if (state.screen !== 'builder') return;
  var c = getCanvasCoords(e.clientX, e.clientY);
  // custom-cut point drag
  if (interaction.mode === 'cpoint') {
    var d = design();
    if (d.customPoints && d.customPoints[interaction.cpIdx]) {
      d.customPoints[interaction.cpIdx].x = Math.max(0, Math.min(CANVAS_W, c.x));
      d.customPoints[interaction.cpIdx].y = Math.max(0, Math.min(CANVAS_H, c.y));
      render();
    }
    e.preventDefault(); return;
  }
  var l = activeLayer();
  if (!l || !interaction.mode || !interaction.orig) { updateHoverCursor(c.x, c.y); return; }
  var o = interaction.orig;
  if (interaction.mode === 'move') {
    var ncx = o.cx + (c.x - interaction.startX);
    var ncy = o.cy + (c.y - interaction.startY);
    // gentle center snapping to the engrave area (toggleable)
    if (state.snapEnabled) {
      var pr = printRect(), TOL = 7;
      if (Math.abs(ncx - (pr.x + pr.w / 2)) <= TOL) ncx = pr.x + pr.w / 2;
      if (Math.abs(ncy - (pr.y + pr.h / 2)) <= TOL) ncy = pr.y + pr.h / 2;
    }
    l.cx = ncx; l.cy = ncy;
  } else if (interaction.mode === 'scale') {
    var origDist = Math.hypot(o.w / 2, o.h / 2);
    var cur = Math.hypot(c.x - o.cx, c.y - o.cy);
    var f = Math.max(0.08, cur / origDist);
    l.w = o.w * f; l.h = o.h * f;
    els.scale.value = Math.round(Math.max(20, Math.min(420, l.w)));
    els.scaleVal.textContent = Math.round(l.w) + 'px';
  } else if (interaction.mode === 'rotate') {
    l.rotation = Math.atan2(c.y - l.cy, c.x - l.cx) + Math.PI / 2;
    var deg = Math.round(l.rotation * 180 / Math.PI);
    if (deg > 180) deg -= 360;
    els.rot.value = deg;
    els.rotVal.textContent = deg + '°';
  }
  render();
  e.preventDefault();
}
function onPointerUp() {
  interaction.mode = null; interaction.orig = null;
  canvas.style.cursor = '';
}
function updateHoverCursor(x, y) {
  var l = activeLayer();
  if (l) {
    var h = hitHandle(l, x, y);
    if (h) { canvas.style.cursor = h.type === 'rotate' ? 'alias' : 'nwse-resize'; return; }
  }
  canvas.style.cursor = findLayerAt(x, y) ? 'move' : 'default';
}

canvas.addEventListener('mousedown', onPointerDown);
window.addEventListener('mousemove', onPointerMove);
window.addEventListener('mouseup', onPointerUp);
canvas.addEventListener('touchstart', function (e) {
  var t = e.touches[0]; if (!t) return;
  onPointerDown({ clientX: t.clientX, clientY: t.clientY, preventDefault: function () { e.preventDefault(); } });
}, { passive: false });
canvas.addEventListener('touchmove', function (e) {
  var t = e.touches[0]; if (!t) return;
  onPointerMove({ clientX: t.clientX, clientY: t.clientY, preventDefault: function () { e.preventDefault(); } });
}, { passive: false });
canvas.addEventListener('touchend', onPointerUp);
canvas.addEventListener('touchcancel', onPointerUp);

/* ══════════════════════════════════════════
   PRICING
══════════════════════════════════════════ */
function unitPrice() {
  var p = product(), d = design();
  var qty = d.quantity, unit = p.basePrice;
  for (var i = 0; i < p.tiers.length; i++) if (qty >= p.tiers[i].minQty) unit = p.tiers[i].price;
  if (p.sidesAvailable === 2 && d.sidesMode === 2 && p.twoSidedSurcharge) unit += p.twoSidedSurcharge;
  return unit;
}
function refreshPricing() {
  if (state.screen !== 'builder') return;
  var p = product(), d = design();
  var unit = unitPrice(), total = unit * d.quantity;
  els.priceTotal.textContent = '$' + total.toFixed(2);
  els.mobileTotal.textContent = '$' + total.toFixed(2);
  var unitTxt = d.quantity + ' × $' + unit.toFixed(2) + ' each';
  if (p.sidesAvailable === 2 && d.sidesMode === 2 && p.twoSidedSurcharge) unitTxt += ' (incl. $' + p.twoSidedSurcharge.toFixed(2) + ' 2-sided)';
  els.priceUnit.textContent = unitTxt;
  els.tierHint.textContent = p.tierHint || '';
}
els.qtyInput.addEventListener('input', function () {
  var v = Math.max(1, Math.min(10000, parseInt(els.qtyInput.value, 10) || 1));
  design().quantity = v;
  refreshPricing(); syncQtyPresets();
});
els.qtyInput.addEventListener('blur', function () { els.qtyInput.value = design().quantity; });
els.qtyMinus.addEventListener('click', function () { design().quantity = Math.max(1, design().quantity - 1); els.qtyInput.value = design().quantity; refreshPricing(); syncQtyPresets(); });
els.qtyPlus.addEventListener('click', function () { design().quantity = Math.min(10000, design().quantity + 1); els.qtyInput.value = design().quantity; refreshPricing(); syncQtyPresets(); });

function renderQtyPresets() {
  var p = product();
  var list = (p && p.qtyPresets) || [];
  els.qtyPresets.innerHTML = list.map(function (n) {
    return '<button type="button" class="bst-qty-preset" data-qty="' + n + '">' + n + '</button>';
  }).join('');
  els.qtyPresets.querySelectorAll('[data-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      design().quantity = parseInt(b.dataset.qty, 10);
      els.qtyInput.value = design().quantity;
      refreshPricing(); syncQtyPresets();
    });
  });
  syncQtyPresets();
}
function syncQtyPresets() {
  var q = design() ? design().quantity : null;
  els.qtyPresets.querySelectorAll('[data-qty]').forEach(function (b) {
    b.classList.toggle('active', parseInt(b.dataset.qty, 10) === q);
  });
}

/* ── ZOOM controls ── */
if (els.zoomSlider) els.zoomSlider.addEventListener('input', function () { applyZoom(parseInt(this.value, 10) / 100); });
if (els.zoomReset)  els.zoomReset.addEventListener('click', function () { resetZoom(); });

/* ── Snapping toggle ── */
if (els.snapToggle) els.snapToggle.addEventListener('click', function () {
  state.snapEnabled = !state.snapEnabled;
  els.snapToggle.classList.toggle('active-tool', state.snapEnabled);
  els.snapToggle.textContent = state.snapEnabled ? '⊹ Snap: On' : '⊹ Snap: Off';
});

/* ══════════════════════════════════════════
   NOTES + CONFIRMATIONS
══════════════════════════════════════════ */
els.notes.addEventListener('input', function () { design().notes = els.notes.value; });
els.confirmDesign.addEventListener('change', function () { design().confirmed = els.confirmDesign.checked; refreshAddToCart(); });
els.confirmRights.addEventListener('change', function () { design().rightsConfirmed = els.confirmRights.checked; refreshAddToCart(); });

/* ══════════════════════════════════════════
   VARIANT RESOLUTION + ADD TO CART
══════════════════════════════════════════ */
function currentVariantId() {
  var p = product(), d = design();
  if (p.key === 'patch') {
    var c = patchColor();
    return c && c.variants ? c.variants[d.backing] : null;
  }
  if (p.key === 'tumbler') {
    var col = tumblerColor();
    if (col && col.variants) return d.sidesMode === 2 ? col.variants.twoSided : col.variants.oneSided;
    var m = tumblerModel();
    return d.sidesMode === 2 ? m.variants.twoSided : m.variants.oneSided;
  }
  if (p.key === 'keychain') {
    var c = keychainColor();
    return c && c.variantId;
  }
  return null;
}

function sidesInOrder() {
  var d = design();
  return d.sidesMode === 2 ? [1, 2] : [1];
}

function refreshAddToCart() {
  if (state.screen !== 'builder') return;
  var d = design();
  var hasArt = sidesInOrder().some(function (n) { return d.sides[n].layers.length > 0; });
  var hasVariant = !!currentVariantId();
  var ready = hasArt && d.confirmed && d.rightsConfirmed && hasVariant;
  els.addToCartBtn.disabled = !ready;
  els.mobileAddBtn.disabled = !ready;
  // colors/options still awaiting a Shopify variant: previewable, not orderable
  if (hasArt && !hasVariant) {
    showCartMsg('This option can be previewed but isn\u2019t available to order online yet.', 'info');
  }
}

function showCartMsg(text, kind) {
  if (!text) { els.cartMsg.style.display = 'none'; return; }
  els.cartMsg.style.display = 'block';
  els.cartMsg.textContent = text;
  if (kind === 'error') {
    els.cartMsg.style.background = 'rgba(231,76,60,0.10)';
    els.cartMsg.style.border = '1px solid rgba(231,76,60,0.35)';
    els.cartMsg.style.color = '#ff8370';
  } else if (kind === 'success') {
    els.cartMsg.style.background = 'rgba(46,160,67,0.10)';
    els.cartMsg.style.border = '1px solid rgba(46,160,67,0.35)';
    els.cartMsg.style.color = '#6dd28b';
  } else {
    els.cartMsg.style.background = 'rgba(201,146,42,0.09)';
    els.cartMsg.style.border = '1px solid rgba(201,146,42,0.30)';
    els.cartMsg.style.color = '#e0a730';
  }
  els.cartMsg.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
}

function canvasToBlob(cvs) {
  return new Promise(function (resolve, reject) {
    cvs.toBlob(function (b) { b ? resolve(b) : reject(new Error('export failed')); }, 'image/png', 1.0);
  });
}

/* Clean mockup of one side (what the customer sees, no guides) */
function exportMockup(side) {
  var off = document.createElement('canvas');
  off.width = CANVAS_W * 2; off.height = CANVAS_H * 2;
  var octx = off.getContext('2d');
  octx.scale(2, 2);
  renderScene(octx, side, 2);
  return off;
}

/* Engrave-area-only, black-on-transparent production artwork for one side */
function exportProductionArtwork(side) {
  var p = product();
  var pr = (p.key === 'patch') ? (isCustomCut() ? customBBox() : productImageRect()) : printRect();
  var MAX_SCALE = 6, best = 3;
  sideLayersOf(side).forEach(function (l) {
    if (l.type !== 'image' || !l.img) return;
    best = Math.max(best,
      (l.img.naturalWidth || l.img.width) / Math.max(1, l.w),
      (l.img.naturalHeight || l.img.height) / Math.max(1, l.h));
  });
  var SCALE = Math.min(MAX_SCALE, Math.ceil(best));
  var off = document.createElement('canvas');
  off.width = Math.round(pr.w * SCALE);
  off.height = Math.round(pr.h * SCALE);
  var octx = off.getContext('2d');
  octx.scale(SCALE, SCALE);
  octx.translate(-pr.x, -pr.y);
  sideLayersOf(side).forEach(function (l) {
    octx.save();
    octx.translate(l.cx, l.cy);
    octx.rotate(l.rotation);
    if (l.type === 'image' && l.img) {
      drawImageMarks(octx, l);
    } else if (l.type === 'text') {
      var fs = Math.max(8, l.h);
      octx.font = l.weight + ' ' + fs + 'px ' + l.font;
      octx.textAlign = 'center';
      octx.textBaseline = 'middle';
      octx.fillStyle = '#000';
      octx.fillText(l.text, 0, 0);
    }
    octx.restore();
  });
  return off;
}

function handleAddToCart() {
  var p = product(), d = design();
  var sides = sidesInOrder();

  var anyArt = sides.some(function (n) { return d.sides[n].layers.length > 0; });
  if (!anyArt) { showCartMsg('Add at least one layer first.', 'error'); return; }
  if (d.sidesMode === 2 && !d.sides[2].layers.length) {
    showCartMsg('Side 2 is empty — add layers, use "Copy Side 1 → Side 2", or switch back to 1-sided.', 'error');
    return;
  }
  if (d.sidesMode === 2 && !d.sides[1].layers.length) {
    showCartMsg('Side 1 is empty — add your front design first.', 'error');
    return;
  }
  if (!d.confirmed)        { showCartMsg('Please confirm the mockup represents your design.', 'error'); return; }
  if (!d.rightsConfirmed)  { showCartMsg('Please confirm you have rights to use the submitted artwork.', 'error'); return; }

  var variantId = currentVariantId();
  if (!variantId || String(variantId).indexOf('REPLACE_WITH_') === 0) {
    showCartMsg('Product not configured yet — the variant ID for this selection is missing in the config.', 'error');
    return;
  }
  if (window.location.protocol === 'file:') {
    showCartMsg('Demo mode: Add to Cart only works once this is installed on your Shopify store. Use Download Mockup to verify the artwork output in the meantime.', 'info');
    return;
  }

  els.addToCartBtn.disabled = true;
  els.mobileAddBtn.disabled = true;
  els.addToCartBtn.textContent = 'Preparing files…';
  showCartMsg('Building your artwork…', 'info');

  // mockup + production artwork for each ordered side
  var jobs = [];
  sides.forEach(function (n) {
    jobs.push(canvasToBlob(exportMockup(n)));
    jobs.push(canvasToBlob(exportProductionArtwork(n)));
  });

  Promise.all(jobs).then(function (blobs) {
    var ts = Date.now();
    var form = new FormData();
    form.append('id', variantId);
    form.append('quantity', String(d.quantity));

    form.append('properties[Product]', p.label);
    if (p.key === 'patch') {
      var s = patchShape(), b = null, pcol = patchColor();
      for (var i = 0; i < PATCH_BACKINGS.length; i++) if (PATCH_BACKINGS[i].key === d.backing) b = PATCH_BACKINGS[i];
      form.append('properties[Patch Color]', pcol ? pcol.label : d.patchColor);
      if (d.shape === 'custom') {
        form.append('properties[Patch Shape]', 'Custom Cut');
        var bb = customBBox();
        var hIn = (typeof d.customHeightIn === 'number') ? d.customHeightIn : 1.75;
        var wIn = bb.h > 0 ? (hIn * bb.w / bb.h) : hIn;
        form.append('properties[Patch Size]', wIn.toFixed(2) + '" W x ' + hIn.toFixed(2) + '" H');
      } else {
        form.append('properties[Patch Shape]', s ? s.label : d.shape);
        var pdc = presetDims();
        form.append('properties[Patch Size]', pdc.wIn.toFixed(2) + '" W x ' + pdc.hIn.toFixed(2) + '" H');
        if (d.shapeRotation) form.append('properties[Shape Orientation]', d.shapeRotation + '\u00b0 rotated');
      }
      form.append('properties[Backing]', b ? b.label : d.backing);
    }
    if (p.key === 'tumbler') {
      var tmm = tumblerModel(), tcol = tumblerColor();
      form.append('properties[Tumbler Style]', tmm.label);
      form.append('properties[Tumbler Color]', tcol ? tcol.label : 'Black');
      form.append('properties[Lid Selection]', tmm.lid.label);
      var prc = printRect();
      var inW = tmm.engraveWidthInches;
      var inH = inW * (prc.h / prc.w);
      form.append('properties[Engrave Area]',
        inW.toFixed(2).replace(/\.?0+$/, '') + '" x ' + inH.toFixed(2).replace(/\.?0+$/, '') + '" per side');
    }
    if (p.key === 'keychain') {
      var c = keychainColor();
      form.append('properties[Keychain Color]', c ? c.label : d.color);
    }
    if (p.sidesAvailable === 2) {
      form.append('properties[Engrave Sides]', d.sidesMode === 2 ? '2-Sided' : '1-Sided');
    }

    // per-side files + text/QR summaries + layer sources
    sides.forEach(function (n, si) {
      var prefix = (sides.length === 2) ? ('Side ' + n + ' ') : '';
      form.append('properties[' + prefix + 'Generated Mockup]',
        new File([blobs[si * 2]], 'mockup-side' + n + '-' + ts + '.png', { type: 'image/png' }));
      form.append('properties[' + prefix + 'Production Artwork]',
        new File([blobs[si * 2 + 1]], 'production-side' + n + '-' + ts + '.png', { type: 'image/png' }));

      var ls = d.sides[n].layers;
      form.append('properties[' + prefix + 'Layer Count]', String(ls.length));

      var texts = ls.filter(function (l) { return l.type === 'text'; })
                    .map(function (l) { return '"' + l.text + '"'; }).join(' · ');
      if (texts) form.append('properties[' + prefix + 'Text Content]', texts);

      var qrs = ls.filter(function (l) { return l.subtype === 'qr'; })
                  .map(function (l) { return l.qrText; }).join(' · ');
      if (qrs) form.append('properties[' + prefix + 'QR Content]', qrs);

      ls.forEach(function (l, idx) {
        var label = prefix + 'Layer ' + (idx + 1) + ' Source';
        if (l.type === 'image' && l.file) {
          var safe = (l.file.name || ('layer-' + (idx + 1))).replace(/[^\w.\-]+/g, '_');
          form.append('properties[' + label + ']',
            new File([l.file], 'side' + n + '-layer' + (idx + 1) + '-' + safe, { type: l.file.type }));
        } else if (l.type === 'text') {
          var blob = new Blob(['Text: "' + l.text + '"\nFont: ' + l.font + '\nWeight: ' + l.weight + '\n'], { type: 'text/plain' });
          form.append('properties[' + label + ']',
            new File([blob], 'side' + n + '-layer' + (idx + 1) + '-text.txt', { type: 'text/plain' }));
        } else if (l.subtype === 'qr') {
          var qblob = new Blob(['QR Content: ' + l.qrText + '\n'], { type: 'text/plain' });
          form.append('properties[' + label + ']',
            new File([qblob], 'side' + n + '-layer' + (idx + 1) + '-qr.txt', { type: 'text/plain' }));
        }
      });
    });

    if (d.notes && d.notes.trim()) form.append('properties[Design Notes]', d.notes.trim());

    var now = new Date();
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var stamp = now.getFullYear() + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate()) +
                ' ' + pad(now.getHours()) + ':' + pad(now.getMinutes());
    form.append('properties[Customer Confirmation]', 'ACKNOWLEDGED - ' + stamp);
    form.append('properties[Artwork Rights]', 'ACKNOWLEDGED - ' + stamp);

    return fetch('/cart/add.js', { method: 'POST', body: form, credentials: 'same-origin' });
  }).then(function (resp) {
    if (!resp.ok) {
      return resp.json().catch(function () { return {}; }).then(function (err) {
        throw new Error(err.description || err.message || 'Shopify rejected the request (' + resp.status + ').');
      });
    }
    return resp.json();
  }).then(function () {
    showCartMsg('✓ Added to cart! Redirecting…', 'success');
    setTimeout(function () { window.location.href = '/cart'; }, 700);
  }).catch(function (err) {
    console.error('[PatchBuilt] Add to cart failed:', err);
    showCartMsg('Couldn\u2019t add to cart: ' + err.message, 'error');
    els.addToCartBtn.textContent = '🛒 Add to Cart';
    refreshAddToCart();
  });
}
els.addToCartBtn.addEventListener('click', handleAddToCart);
els.mobileAddBtn.addEventListener('click', function () {
  if (els.mobileAddBtn.disabled) return;
  handleAddToCart();
});

/* ══════════════════════════════════════════
   DOWNLOAD MOCKUPS (also verifies artwork in demo mode)
══════════════════════════════════════════ */
function triggerDownload(cvs, name) {
  return canvasToBlob(cvs).then(function (blob) {
    var a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = name;
    document.body.appendChild(a);
    a.click();
    setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1500);
  });
}
els.downloadBtn.addEventListener('click', function () {
  var d = design(), p = product(), ts = Date.now();
  var chain = Promise.resolve();
  sidesInOrder().forEach(function (n) {
    if (!d.sides[n].layers.length) return;
    chain = chain
      .then(function () { return triggerDownload(exportMockup(n), 'patchbuilt-' + p.key + '-side' + n + '-mockup-' + ts + '.png'); });
  });
  chain.then(function () { setStatus('Mockup picture downloaded for each designed side.'); });
});

/* ══════════════════════════════════════════
   MISC
══════════════════════════════════════════ */
function setStatus(t) { els.status.textContent = t; }

// re-render once fonts are ready so text layers measure correctly
if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { render(); });

})();
